{
  "#{tag}": "#{tag}",
  "(Masked)": "(Masked)",
  "(No label defined)" : "(No label defined",
  "(this folder)": "(this folder)",
  "(this link)": "(this link)",
  "+ Add a resource": "+ Add a resource",
  "+ Create a post": "+ Create a post",
  "+ Create an activity": "+ Create an activity",
  "+ Create an event": "+ Create an event",
  "+ Start a discussion": "+ Start a discussion",
  "+ View past activities": "+ View past activities",
  "+ View past events": "+ View past events",
  "0 Bytes": "0 Bytes",
  "<b>{contact}</b> will be displayed as contact.": "<b>{contact}</b> will be displayed as contact.|<b>{contact}</b> will be displayed as contacts.",
  "@{group}": "@{group}",
  "@{username} ({role})": "@{username} ({role})",
  "@{username}'s follow request was accepted": "@{username}'s follow request was accepted",
  "@{username}'s follow request was rejected": "@{username}'s follow request was rejected",
  "A cookie is a small file containing information that is sent to your computer when you visit a website. When you visit the site again, the cookie allows that site to recognize your browser. Cookies may store user preferences and other information. You can configure your browser to refuse all cookies. However, this may result in some website features or services partially working. Local storage works the same way but allows you to store more data.": "A cookie is a small file containing information that is sent to your computer when you visit a website. When you visit the site again, the cookie allows that site to recognize your browser. Cookies may store user preferences and other information. You can configure your browser to refuse all cookies. However, this may result in some website features or services partially working. Local storage works the same way but allows you to store more data.",
  "A discussion has been created or updated": "A discussion has been created or updated",
  "A federated software": "A federated software",
  "A fediverse account URL to follow for event updates": "A fediverse account URL to follow for event updates",
  "A few lines about your group": "A few lines about your group",
  "A link to a page presenting the event schedule": "A link to a page presenting the event schedule",
  "A link to a page presenting the price options": "A link to a page presenting the price options",
  "A member has been updated": "A member has been updated",
  "A member requested to join one of my groups": "A member requested to join one of my groups",
  "A moderator will take care of your request.": "A moderator will take care of your request.",
  "A new version is available.": "A new version is available.",
  "A place for your code of conduct, rules or guidelines. You can use HTML tags.": "A place for your code of conduct, rules or guidelines. You can use HTML tags.",
  "A place to explain who you are and the things that set your instance apart. You can use HTML tags.": "A place to explain who you are and the things that set your instance apart. You can use HTML tags.",
  "A place to publish something to the whole world, your community or just your group members.": "A place to publish something to the whole world, your community or just your group members.",
  "A place to store links to documents or resources of any type.": "A place to store links to documents or resources of any type.",
  "A post has been published": "A post has been published",
  "A post has been updated": "A post has been updated",
  "A practical tool": "A practical tool",
  "A resource has been created or updated": "A resource has been created or updated",
  "A short tagline for your instance homepage. Defaults to \"Gather \u22c5 Organize \u22c5 Mobilize\"": "A short tagline for your instance homepage. Defaults to \"Gather \u22c5 Organize \u22c5 Mobilize\"",
  "A twitter account handle to follow for event updates": "A twitter account handle to follow for event updates",
  "A user-friendly, emancipatory and ethical tool for gathering, organising, and mobilising.": "A user-friendly, emancipatory and ethical tool for gathering, organising, and mobilising.",
  "A validation email was sent to {email}": "A validation email was sent to {email}",
  "API": "API",
  "Abandon editing": "Abandon editing",
  "About Mobilizon": "About Mobilizon",
  "About anonymous participation": "About anonymous participation",
  "About instance": "About instance",
  "About this event": "About this event",
  "About this instance": "About this instance",
  "About {instance}": "About {instance}",
  "About": "About",
  "Accept follow": "Accept follow",
  "Accept": "Accept",
  "Accepted": "Accepted",
  "Access drafts events": "Access drafts events",
  "Access followed groups": "Access followed groups",
  "Access group activities": "Access group activities",
  "Access group discussions": "Access group discussions",
  "Access group events": "Access group events",
  "Access group followers": "Access group followers",
  "Access group members": "Access group members",
  "Access group memberships": "Access group memberships",
  "Access group suggested events": "Access group suggested events",
  "Access group todo-lists": "Access group todo-lists",
  "Access organized events": "Access organized events",
  "Access participations": "Access participations",
  "Access your group's resources": "Access your group's resources",
  "Accessibility": "Accessibility",
  "Accessible only by link": "Accessible only by link",
  "Accessible only to members": "Accessible only to members",
  "Accessible through link": "Accessible through link",
  "Account settings": "Account settings",
  "Account": "Account",
  "Actions": "Actions",
  "Activate browser push notifications": "Activate browser push notifications",
  "Activate notifications": "Activate notifications",
  "Activated": "Activated",
  "Active": "Active",
  "Activities are disabled on this instance.|An event with a duration of more than one day will be categorized as an activity.|An event with a duration of more than {number} days will be categorized as an activity.": "Activities are disabled on this instance.|An event with a duration of more than one day will be categorized as an activity.|An event with a duration of more than {number} days will be categorized as an activity.",
  "Activities": "Activities",
  "Activity": "Activity",
  "Actor": "Actor",
  "Adapt to system theme": "Adapt to system theme",
  "Add / Remove\u2026": "Add / Remove\u2026",
  "Add a contact": "Add a contact",
  "Add a new link": "Add a new link",
  "Add a new post": "Add a new post",
  "Add a note": "Add a note",
  "Add a recipient": "Add a recipient",
  "Add a todo": "Add a todo",
  "Add an address": "Add an address",
  "Add an instance": "Add an instance",
  "Add link": "Add link",
  "Add new\u2026": "Add new\u2026",
  "Add picture": "Add picture",
  "Add some tags": "Add some tags",
  "Add to my calendar": "Add to my calendar",
  "Add": "Add",
  "Additional comments": "Additional comments",
  "Admin dashboard": "Admin dashboard",
  "Admin settings successfully saved.": "Admin settings successfully saved.",
  "Admin settings": "Admin settings",
  "Admin": "Admin",
  "Administration": "Administration",
  "Administrator": "Administrator",
  "All activities": "All activities",
  "All good, let's continue!": "All good, let's continue!",
  "All the places have already been taken": "All the places have already been taken",
  "All": "All",
  "Allow all comments from users with accounts": "Allow all comments from logged-in users",
  "Allow registrations": "Allow registrations",
  "An URL to an external ticketing platform": "An URL to an external ticketing platform",
  "An \u201capplication programming interface\u201d or \u201cAPI\u201d is a communication protocol that allows software components to communicate with each other. The Mobilizon API, for example, can allow third-party software tools to communicate with Mobilizon instances to carry out certain actions, such as posting events on your behalf, automatically and remotely.": "An \u201capplication programming interface\u201d or \u201cAPI\u201d is a communication protocol that allows software components to communicate with each other. The Mobilizon API, for example, can allow third-party software tools to communicate with Mobilizon instances to carry out certain actions, such as posting events on your behalf, automatically and remotely.",
  "An \u201capplication programming interface\u201d or \u201cAPI\u201d is a communication protocol that allows software components to communicate with each other. The Mobilizon API, for example, can allow third-party software tools to communicate with Mobilizon instances to carry out certain actions, such as posting events, automatically and remotely.": "An \u201capplication programming interface\u201d or \u201cAPI\u201d is a communication protocol that allows software components to communicate with each other. The Mobilizon API, for example, can allow third-party software tools to communicate with Mobilizon instances to carry out certain actions, such as posting events, automatically and remotely.",
  "An anonymous profile joined the event {event}.": "An anonymous profile joined the event {event}.",
  "An error has occured while refreshing the page.": "An error has occured while refreshing the page.",
  "An error has occured. Sorry about that. You may try to reload the page.": "An error has occured. Sorry about that. You may try to reload the page.",
  "An ethical alternative": "An ethical alternative",
  "An event I'm going to has been updated": "An event I'm going to has been updated",
  "An event I'm going to has posted an announcement": "An event I'm going to has posted an announcement",
  "An event I'm organizing has a new comment": "An event I'm organizing has a new comment",
  "An event I'm organizing has a new participation": "An event I'm organizing has a new participation",
  "An event I'm organizing has a new pending participation": "An event I'm organizing has a new pending participation",
  "An event from one of my groups has been published": "An event from one of my groups has been published",
  "An event from one of my groups has been updated or deleted": "An event from one of my groups has been updated or deleted",
  "An instance is an installed version of the Mobilizon software running on a server. An instance can be run by anyone using the {mobilizon_software} or other federated apps, aka the \u201cfediverse\u201d. This instance's name is {instance_name}. Mobilizon is a federated network of multiple instances (just like email servers), users registered on different instances may communicate even though they didn't register on the same instance.": "An instance is an installed version of the Mobilizon software running on a server. An instance can be run by anyone using the {mobilizon_software} or other federated apps, aka the \u201cfediverse\u201d. This instance's name is {instance_name}. Mobilizon is a federated network of multiple instances (just like email servers), users registered on different instances may communicate even though they didn't register on the same instance.",
  "And {number} comments": "And {number} comments",
  "Announcements and mentions notifications are always sent straight away.": "Announcements and mentions notifications are always sent straight away.",
  "Announcements for {eventTitle}": "Announcements for {eventTitle}",
  "Announcements": "Announcements",
  "Anonymous participant": "Anonymous participant",
  "Anonymous participants will be asked to confirm their participation through e-mail.": "Anonymous participants will be asked to confirm their participation through e-mail.",
  "Anonymous participations": "Anonymous participations",
  "Any category": "Any category",
  "Any day": "Any day",
  "Any distance": "Any distance",
  "Any type": "Any type",
  "Anyone can join freely": "Anyone can join freely",
  "Anyone can request being a member, but an administrator needs to approve the membership.": "Anyone can request being a member, but an administrator needs to approve the membership.",
  "Anyone wanting to be a member from your group will be able to from your group page.": "Anyone wanting to be a member from your group will be able to from your group page.",
  "Application authorized": "Application authorized",
  "Application not found": "Application not found",
  "Application was revoked": "Application was revoked",
  "Application": "Application",
  "Apply filters": "Apply filters",
  "Approve member": "Approve member",
  "Apps": "Apps",
  "Are you really sure you want to delete your whole account? You'll lose everything. Identities, settings, events created, messages and participations will be gone forever.": "Are you really sure you want to delete your whole account? You'll lose everything. Identities, settings, events created, messages and participations will be gone forever.",
  "Are you sure you want to <b>completely delete</b> this group? All members - including remote ones - will be notified and removed from the group, and <b>all of the group data (events, posts, discussions\u2026) will be irretrievably destroyed</b>.": "Are you sure you want to <b>completely delete</b> this group? All members - including remote ones - will be notified and removed from the group, and <b>all of the group data (events, posts, discussions\u2026) will be irretrievably destroyed</b>.",
  "Are you sure you want to <b>delete</b> this comment? <b>This action cannot be undone</b>.": "Are you sure you want to <b>delete</b> this comment? <b>This action cannot be undone</b>.",
  "Are you sure you want to <b>delete</b> this comment? This action cannot be undone.": "Are you sure you want to <b>delete</b> this comment? This action cannot be undone.",
  "Are you sure you want to <b>delete</b> this event? <b>This action cannot be undone</b>. You may want to engage the discussion with the event creator and ask them to edit their event instead.": "Are you sure you want to <b>delete</b> this event? <b>This action cannot be undone</b>. You may want to engage the discussion with the event creator and ask them to edit their event instead.",
  "Are you sure you want to <b>delete</b> this event? This action cannot be undone. You may want to engage the discussion with the event creator or edit its event instead.": "Are you sure you want to <b>delete</b> this event? This action cannot be undone. You may want to engage the discussion with the event creator or edit its event instead.",
  "Are you sure you want to <b>suspend</b> this group? All members - including remote ones - will be notified and removed from the group, and <b>all of the group data (events, posts, discussions\u2026) will be irretrievably destroyed</b>.": "Are you sure you want to <b>suspend</b> this group? All members - including remote ones - will be notified and removed from the group, and <b>all of the group data (events, posts, discussions\u2026) will be irretrievably destroyed</b>.",
  "Are you sure you want to <b>suspend</b> this group? As this group originates from instance {instance}, this will only remove local members and delete the local data, as well as rejecting all the future data.": "Are you sure you want to <b>suspend</b> this group? As this group originates from instance {instance}, this will only remove local members and delete the local data, as well as rejecting all the future data.",
  "Are you sure you want to cancel the event creation? You'll lose all modifications.": "Are you sure you want to cancel the event creation? You'll lose all modifications.",
  "Are you sure you want to cancel the event edition? You'll lose all modifications.": "Are you sure you want to cancel the event edition? You'll lose all modifications.",
  "Are you sure you want to cancel your participation at event \"{title}\"?": "Are you sure you want to cancel your participation at event \"{title}\"?",
  "Are you sure you want to delete this entire conversation?": "Are you sure you want to delete this entire conversation?",
  "Are you sure you want to delete this entire discussion?": "Are you sure you want to delete this entire discussion?",
  "Are you sure you want to delete this event? This action cannot be reverted.": "Are you sure you want to delete this event? This action cannot be reverted.",
  "Are you sure you want to delete this post? This action cannot be reverted.": "Are you sure you want to delete this post? This action cannot be reverted.",
  "Are you sure you want to leave the group {groupName}? You'll loose access to this group's private content. This action cannot be undone.": "Are you sure you want to leave the group {groupName}? You'll loose access to this group's private content. This action cannot be undone.",
  "As the event organizer has chosen to manually validate participation requests, your participation will be really confirmed only once you receive an email stating it's being accepted.": "As the event organizer has chosen to manually validate participation requests, your participation will be really confirmed only once you receive an email stating it's being accepted.",
  "Ask your instance admin to {enable_feature}.": "Ask your instance admin to {enable_feature}.",
  "Assigned to": "Assigned to",
  "Atom feed for events and posts": "Atom feed for events and posts",
  "Atom feed for events": "Atom feed for events",
  "Attending": "Attending",
  "Authorize application": "Authorize application",
  "Authorize": "Authorize",
  "Authorized on {authorization_date}": "Authorized on {authorization_date}",
  "Autorize this application to access your account?": "Autorize this application to access your account?",
  "Avatar": "Avatar",
  "Back to group list": "Back to group list",
  "Back to homepage": "Back to homepage",
  "Back to previous page": "Back to previous page",
  "Back to profile list": "Back to profile list",
  "Back to top": "Back to top",
  "Back to user list": "Back to user list",
  "Ban the account": "Ban the account",
  "Ban the account?": "Ban the account?",
  "Ban": "Ban",
  "Banner": "Banner",
  "Become part of the community and start organizing events": "Become part of the community and start organizing events",
  "Before you can login, you need to click on the link inside it to validate your account.": "Before you can login, you need to click on the link inside it to validate your account.",
  "Begins on": "Begins on",
  "Best match": "Best match",
  "Big Blue Button": "Big Blue Button",
  "Bold": "Bold",
  "Booking": "Booking",
  "Breadcrumbs": "Breadcrumbs",
  "Browser notifications": "Browser notifications",
  "Browser tab icon and PWA icon of the instance. Defaults to the upstream Mobilizon icon.": "Browser tab icon and PWA icon of the instance. Defaults to the upstream Mobilizon icon.",
  "Bullet list": "Bullet list",
  "By bike": "By bike",
  "By car": "By car",
  "By others": "By others",
  "By transit": "By transit",
  "By {group}": "By {group}",
  "By {username}": "By {username}",
  "Calendar": "Calendar",
  "Can be an email or a link, or just plain text.": "Can be an email or a link, or just plain text.",
  "Cancel anonymous participation": "Cancel anonymous participation",
  "Cancel creation": "Cancel creation",
  "Cancel discussion title edition": "Cancel discussion title edition",
  "Cancel edition": "Cancel edition",
  "Cancel follow request": "Cancel follow request",
  "Cancel membership request": "Cancel membership request",
  "Cancel my participation request\u2026": "Cancel my participation request\u2026",
  "Cancel my participation\u2026": "Cancel my participation\u2026",
  "Cancel participation": "Cancel participation",
  "Cancel update":"Cancel update",
  "Cancel": "Cancel",
  "Cancelled": "Cancelled",
  "Cancelled: Won't happen": "Cancelled: Won't happen",
  "Categories": "Categories",
  "Category illustrations credits": "Category illustrations credits",
  "Category list": "Category list",
  "Category": "Category",
  "Change email": "Change email",
  "Change my email": "Change my email",
  "Change my identity\u2026": "Change my identity\u2026",
  "Change my password": "Change my password",
  "Change role": "Change role",
  "Change the filters.": "Change the filters.",
  "Change timezone": "Change timezone",
  "Change user email": "Change user email",
  "Change user role": "Change user role",
  "Change": "Change",
  "Check your device to continue. You may now close this window.": "Check your device to continue. You may now close this window.",
  "Check your inbox (and your junk mail folder).": "Check your inbox (and your junk mail folder).",
  "Choose publishing": "Choose publishing",
  "Choose the source of the instance's Privacy Policy": "Choose the source of the instance's Privacy Policy",
  "Choose the source of the instance's Terms": "Choose the source of the instance's Terms",
  "City or region": "City or region",
  "Clear address field": "Clear address field",
  "Clear date filter field": "Clear date filter field",
  "Clear participation data for all events": "Clear participation data for all events",
  "Clear participation data for this event": "Clear participation data for this event",
  "Clear timezone field": "Clear timezone field",
  "Clear": "Clear",
  "Click for more information": "Click for more information",
  "Click to upload": "Click to upload",
  "Close comments for all (except for admins)": "Close comments for all (except for admins)",
  "Close map": "Close map",
  "Close": "Close",
  "Closed": "Closed",
  "Comment body": "Comment body",
  "Comment deleted and report resolved": "Comment deleted and report resolved",
  "Comment deleted": "Comment deleted",
  "Comment from a private conversation": "Comment from a private conversation",
  "Comment from an event announcement": "Comment from an event announcement",
  "Comment from {'@'}{username} reported": "Comment from {'@'}{username} reported",
  "Comment text can't be empty": "Comment text can't be empty",
  "Comment under event {eventTitle}": "Comment under event {eventTitle}",
  "Comments are closed for everybody else.": "Comments are closed for everybody else.",
  "Comments": "Comments",
  "Confirm my participation": "Confirm my participation",
  "Confirm my particpation": "Confirm my particpation",
  "Confirm participation": "Confirm participation",
  "Confirm user": "Confirm user",
  "Confirm": "Confirm",
  "Confirmed at": "Confirmed at",
  "Confirmed": "Confirmed",
  "Confirmed: Will happen": "Confirmed: Will happen",
  "Congratulations, your account is now created!": "Congratulations, your account is now created!",
  "Contact": "Contact",
  "Continue editing": "Continue editing",
  "Continue": "Continue",
  "Conversation with {participants}": "Conversation with {participants}",
  "Conversations": "Conversations",
  "Cookies and Local storage": "Cookies and Local storage",
  "Copy URL to clipboard": "Copy URL to clipboard",
  "Copy details to clipboard": "Copy details to clipboard",
  "Country": "Country",
  "Create a calc": "Create a calc",
  "Create a discussion": "Create a discussion",
  "Create a folder": "Create a folder",
  "Create a new event or a new activity": "Create a new event or a new activity",
  "Create a new event": "Create a new event",
  "Create a new group": "Create a new group",
  "Create a new identity": "Create a new identity",
  "Create a new list": "Create a new list",
  "Create a new metadata element": "Create a new metadata element",
  "Create a new profile": "Create a new profile",
  "Create a pad": "Create a pad",
  "Create a videoconference": "Create a videoconference",
  "Create an account": "Create an account",
  "Create discussion": "Create discussion",
  "Create event": "Create event",
  "Create feed tokens": "Create feed tokens",
  "Create group discussions": "Create group discussions",
  "Create group resources": "Create group resources",
  "Create group": "Create group",
  "Create identity": "Create identity",
  "Create my event": "Create my event",
  "Create my group": "Create my group",
  "Create my profile": "Create my profile",
  "Create new links": "Create new links",
  "Create new profiles": "Create new profiles",
  "Create resource": "Create resource",
  "Create the discussion": "Create the discussion",
  "Create to-do lists for all the tasks you need to do, assign them and set due dates.": "Create to-do lists for all the tasks you need to do, assign them and set due dates.",
  "Create token": "Create token",
  "Create": "Create",
  "Created by {name}": "Created by {name}",
  "Created by {username}": "Created by {username}",
  "Creation date":"Creation date",
  "Current identity has been changed to {identityName} in order to manage this event.": "Current identity has been changed to {identityName} in order to manage this event.",
  "Current page": "Current page",
  "Custom URL": "Custom URL",
  "Custom text": "Custom text",
  "Custom": "Custom",
  "Daily email summary": "Daily email summary",
  "Dark": "Dark",
  "Dashboard": "Dashboard",
  "Date and time settings": "Date and time settings",
  "Date and time": "Date and time",
  "Date parameters": "Date parameters",
  "Date": "Date",
  "Day": "Day",
  "Deactivate notifications": "Deactivate notifications",
  "Decline": "Decline",
  "Decrease": "Decrease",
  "Decreasing creation date": "Decreasing creation date",
  "Decreasing number of members": "Decreasing number of members",
  "Default Mobilizon privacy policy": "Default Mobilizon privacy policy",
  "Default Mobilizon terms": "Default Mobilizon terms",
  "Default Picture": "Default Picture",
  "Default picture when an event or group doesn't have one.": "Default picture when an event or group doesn't have one.",
  "Default": "Default",
  "Delete account": "Delete account",
  "Delete comment and resolve report": "Delete comment and resolve report",
  "Delete comment": "Delete comment",
  "Delete comments": "Delete comments",
  "Delete conversation": "Delete conversation",
  "Delete discussion": "Delete discussion",
  "Delete event and resolve report": "Delete event and resolve report",
  "Delete event": "Delete event",
  "Delete events": "Delete events",
  "Delete everything": "Delete everything",
  "Delete feed tokens": "Delete feed tokens",
  "Delete group discussions": "Delete group discussions",
  "Delete group posts": "Delete group posts",
  "Delete group resources": "Delete group resources",
  "Delete group": "Delete group",
  "Delete invitation":"Delete invitation",
  "Delete invitation?":"Delete invitation?",
  "Delete my account": "Delete my account",
  "Delete post": "Delete post",
  "Delete profiles": "Delete profiles",
  "Delete this conversation": "Delete this conversation",
  "Delete this discussion": "Delete this discussion",
  "Delete this identity": "Delete this identity",
  "Delete this link": "Delete this link",
  "Delete your identity": "Delete your identity",
  "Delete {eventTitle}": "Delete {eventTitle}",
  "Delete {preferredUsername}": "Delete {preferredUsername}",
  "Delete": "Delete",
  "Deleting comment": "Deleting comment",
  "Deleting event": "Deleting event",
  "Deleting my account will delete all of my identities.": "Deleting my account will delete all of my identities.",
  "Deleting your Mobilizon account": "Deleting your Mobilizon account",
  "Demote": "Demote",
  "Describe your event": "Describe your event",
  "Description": "Description",
  "Deselect all": "Deselect all", 
  "Details": "Details",
  "Device activation": "Device activation",
  "Didn't receive the instructions?": "Didn't receive the instructions?",
  "Disabled": "Disabled",
  "Discussions list": "Discussions list",
  "Discussions": "Discussions",
  "Display name": "Display name",
  "Display participation price": "Display participation price",
  "Displayed nickname": "Displayed nickname",
  "Displayed on homepage and meta tags. Describe what Mobilizon is and what makes this instance special in a single paragraph.": "Displayed on homepage and meta tags. Describe what Mobilizon is and what makes this instance special in a single paragraph.",
  "Distance": "Distance",
  "Do not receive any mail": "Do not receive any mail",
  "Do you really want to ban the account \u00ab\u00a0{emailAccount}\u00a0\u00bb\u00a0?": "Do you really want to ban the account \u00ab\u00a0{emailAccount}\u00a0\u00bb\u00a0?",
  "Do you really want to ban this account? All of the user's profiles will be deleted.": "Do you really want to ban this account? All of the user's profiles will be deleted.",
  "Do you really want to delete this invitation link to this group?":"Do you really want to delete this invitation link to this group?",
  "Do you really want to suspend this profile? All of the profiles content will be deleted.": "Do you really want to suspend this profile? All of the profiles content will be deleted.",
  "Do you really want to unban this account? The user will be able to log-in again.":"Do you really want to unban this account? The user will be able to log-in again.",
  "Do you want to join the group {groupName} with the profile {preferredUsername} ?": "Do you want to join the group {groupName} with the profile {preferredUsername} ?",
  "Do you wish to {create_event} or {explore_events}?": "Do you wish to {create_event} or {explore_events}?",
  "Do you wish to {create_group} or {explore_groups}?": "Do you wish to {create_group} or {explore_groups}?",
  "Does the event needs to be confirmed later or is it cancelled?": "Does the event needs to be confirmed later or is it cancelled?",
  "Domain or instance name": "Domain or instance name",
  "Domain": "Domain",
  "Draft": "Draft",
  "Drafts": "Drafts",
  "Due on": "Due on",
  "Duplicate": "Duplicate",
  "Edit label": "Edit label",
  "Edit post": "Edit post",
  "Edit profile {profile}": "Edit profile {profile}",
  "Edit user email": "Edit user email",
  "Edit": "Edit",
  "Edited {ago}": "Edited {ago}",
  "Edited {relative_time} ago": "Edited {relative_time} ago",
  "Eg: Stockholm, Dance, Chess\u2026": "Eg: Stockholm, Dance, Chess\u2026",
  "Either on the {instance} instance or on another instance.": "Either on the {instance} instance or on another instance.",
  "Either the account is already validated, either the validation token is incorrect.": "Either the account is already validated, either the validation token is incorrect.",
  "Either the email has already been changed, either the validation token is incorrect.": "Either the email has already been changed, either the validation token is incorrect.",
  "Either the participation request has already been validated, either the validation token is incorrect.": "Either the participation request has already been validated, either the validation token is incorrect.",
  "Either your participation has already been cancelled, either the validation token is incorrect.": "Either your participation has already been cancelled, either the validation token is incorrect.",
  "Element title": "Element title",
  "Element value": "Element value",
  "Email address": "Email address",
  "Email validate": "Email validate",
  "Email": "Email",
  "Emails usually don't contain capitals, make sure you haven't made a typo.": "Emails usually don't contain capitals, make sure you haven't made a typo.",
  "Enabled": "Enabled",
  "Ends on\u2026": "Ends on\u2026",
  "Enter the code displayed on your device": "Enter the code displayed on your device",
  "Enter the link URL": "Enter the link URL",
  "Enter your email address below, and we'll email you instructions on how to change your password.": "Enter your email address below, and we'll email you instructions on how to change your password.",
  "Enter your own privacy policy. HTML tags allowed. The {mobilizon_privacy_policy} is provided as template.": "Enter your own privacy policy. HTML tags allowed. The  {mobilizon_privacy_policy} is provided as template.",
  "Enter your own terms. HTML tags allowed. The {mobilizon_terms} are provided as template.": "Enter your own terms. HTML tags allowed. The {mobilizon_terms} are provided as template.",
  "Error details copied!": "Error details copied!",
  "Error message": "Error message",
  "Error stacktrace": "Error stacktrace",
  "Error while adding tag: {error}": "Error while adding tag: {error}",
  "Error while cancelling your participation": "Error while cancelling your participation",
  "Error while changing email": "Error while changing email",
  "Error while loading the preview": "Error while loading the preview",
  "Error while login with {provider}. Retry or login another way.": "Error while login with {provider}. Retry or login another way.",
  "Error while login with {provider}. This login provider doesn't exist.": "Error while login with {provider}. This login provider doesn't exist.",
  "Error while reporting group {groupTitle}": "Error while reporting group {groupTitle}",
  "Error while subscribing to push notifications": "Error while subscribing to push notifications",
  "Error while suspending group": "Error while suspending group",
  "Error while updating participation status inside this browser": "Error while updating participation status inside this browser",
  "Error while validating account": "Error while validating account",
  "Error while validating participation request": "Error while validating participation request",
  "Error": "Error",
  "Etherpad notes": "Etherpad notes",
  "Ethical alternative to Facebook events, groups and pages, Mobilizon is a <b>tool designed to serve you</b>. Period.": "Ethical alternative to Facebook events, groups and pages, Mobilizon is a <b>tool designed to serve you</b>. Period.",
  "Ethical alternative to Facebook events, groups and pages, Mobilizon is a {tool_designed_to_serve_you}. Period.": "Ethical alternative to Facebook events, groups and pages, Mobilizon is a {tool_designed_to_serve_you}. Period.",
  "Event URL": "Event URL",
  "Event already passed": "Event already passed",
  "Event cancelled": "Event cancelled",
  "Event creation": "Event creation",
  "Event date": "Event date",
  "Event deleted and report resolved": "Event deleted and report resolved",
  "Event deleted": "Event deleted",
  "Event description body": "Event description body",
  "Event edition": "Event edition",
  "Event list": "Event list",
  "Event metadata": "Event metadata",
  "Event page settings": "Event page settings",
  "Event status": "Event status",
  "Event timezone will default to the timezone of the event's address if there is one, or to your own timezone setting.": "Event timezone will default to the timezone of the event's address if there is one, or to your own timezone setting.",
  "Event to be confirmed": "Event to be confirmed",
  "Event {eventTitle} deleted": "Event {eventTitle} deleted",
  "Event {eventTitle} reported": "Event {eventTitle} reported",
  "Event": "Event",
  "Events close to you": "Events close to you",
  "Events nearby {position}": "Events nearby {position}",
  "Events nearby": "Events nearby",
  "Events tagged with {tag}": "Events tagged with {tag}",
  "Events": "Events",
  "Everything": "Everything",
  "Ex: mobilizon.fr": "Ex: mobilizon.fr",
  "Ex: someone@mobilizon.org": "Ex: someone@mobilizon.org",
  "Ex: someone{'@'}mobilizon.org": "Ex: someone{'@'}mobilizon.org",
  "Explore events": "Explore events",
  "Explore!": "Explore!",
  "Explore": "Explore",
  "Export": "Export",
  "External links": "External links",
  "External provider URL": "External provider URL",
  "External registration": "External registration",
  "Failed to get location.": "Failed to get location.",
  "Failed to save admin settings": "Failed to save admin settings",
  "Favicon": "Favicon",
  "Featured events": "Featured events",
  "Federated Group Name": "Federated Group Name",
  "Federation": "Federation",
  "Fediverse account": "Fediverse account",
  "Fetch more": "Fetch more",
  "Filter by name": "Filter by name",
  "Filter by profile or group name": "Filter by profile or group name",
  "Filter": "Filter",
  "Find an address": "Find an address",
  "Find an instance": "Find an instance",
  "Find another instance": "Find another instance",
  "Find or add an element": "Find or add an element",
  "First steps": "First steps",
  "Follow a new instance": "Follow a new instance",
  "Follow instance": "Follow instance",
  "Follow request pending approval": "Follow request pending approval",
  "Follow requests will be approved by a group moderator": "Follow requests will be approved by a group moderator",
  "Follow status": "Follow status",
  "Follow": "Follow",
  "Followed": "Followed",
  "Followed, pending response": "Followed, pending response",
  "Follower": "Follower",
  "Followers will receive new public events and posts.": "Followers will receive new public events and posts.",
  "Followers": "Followers",
  "Following the group will allow you to be informed of the {group_upcoming_public_events}, whereas joining the group means you will {access_to_group_private_content_as_well}, including group discussions, group resources and members-only posts.": "Following the group will allow you to be informed of the {group_upcoming_public_events}, whereas joining the group means you will {access_to_group_private_content_as_well}, including group discussions, group resources and members-only posts.",
  "Following": "Following",
  "Followings": "Followings",
  "Follows us": "Follows us",
  "Follows us, pending approval": "Follows us, pending approval",
  "For instance: London": "For instance: London",
  "For instance: London, Taekwondo, Architecture\u2026": "For instance: London, Taekwondo, Architecture\u2026",
  "Framadate poll": "Framadate poll",
  "From my groups": "From my groups",
  "From the {startDate} at {startTime} to the {endDate} at {endTime}": "From the {startDate} at {startTime} to the {endDate} at {endTime}",
  "From the {startDate} at {startTime} to the {endDate}": "From the {startDate} at {startTime} to the {endDate}",
  "From the {startDate} to the {endDate} at {endTime}": "From the {startDate} to the {endDate} at {endTime}",
  "From the {startDate} to the {endDate}": "From the {startDate} to the {endDate}",
  "From this instance only": "From this instance only",
  "From yourself": "From yourself",
  "Fully accessible with a wheelchair": "Fully accessible with a wheelchair",
  "Gather \u22c5 Organize \u22c5 Mobilize": "Gather \u22c5 Organize \u22c5 Mobilize",
  "General information": "General information",
  "General settings": "General settings",
  "General": "General",
  "Geolocate me": "Geolocate me",
  "Geolocation was not determined in time.": "Geolocation was not determined in time.",
  "Get informed of the upcoming public events": "Get informed of the upcoming public events",
  "Getting location": "Getting location",
  "Getting there": "Getting there",
  "Glossary": "Glossary",
  "Go to booking": "Go to booking",
  "Go to the event page": "Go to the event page",
  "Go to the group page": "Go to the group page",
  "Go!": "Go!",
  "Go": "Go",
  "Google Meet": "Google Meet",
  "Group Followers": "Group Followers",
  "Group Members": "Group Members",
  "Group URL": "Group URL",
  "Group activity": "Group activity",
  "Group address": "Group address",
  "Group description body": "Group description body",
  "Group display name": "Group display name",
  "Group invitation links":"Group invitation links",
  "Group invitations": "Group invitations",
  "Group members": "Group members",
  "Group name": "Group name",
  "Group profiles": "Group profiles",
  "Group settings saved": "Group settings saved",
  "Group settings": "Group settings",
  "Group short description": "Group short description",
  "Group visibility": "Group visibility",
  "Group {displayName} created": "Group {displayName} created",
  "Group {groupTitle} reported": "Group {groupTitle} reported",
  "Group": "Group",
  "Groups are not enabled on this instance.": "Groups are not enabled on this instance.",
  "Groups are spaces for coordination and preparation to better organize events and manage your community.": "Groups are spaces for coordination and preparation to better organize events and manage your community.",
  "Groups": "Groups",
  "Heading Level 1": "Heading Level 1",
  "Heading Level 2": "Heading Level 2",
  "Heading Level 3": "Heading Level 3",
  "Headline picture": "Headline picture",
  "Hide filters": "Hide filters",
  "Hide replies": "Hide replies",
  "Hide the number of participants": "Hide the number of participants",
  "Home to {number} users": "Home to {number} users",
  "Home": "Home",
  "Homepage": "Homepage",
  "Hourly email summary": "Hourly email summary",
  "How to register": "How to register",
  "I agree to the {instanceRules} and {termsOfService}": "I agree to the {instanceRules} and {termsOfService}",
  "I create an identity": "I create an identity",
  "I don't have a Mobilizon account": "I don't have a Mobilizon account",
  "I have a Mobilizon account": "I have a Mobilizon account",
  "I have an account on another Mobilizon instance.": "I have an account on another Mobilizon instance.",
  "I have an account on {instance}.": "I have an account on {instance}.",
  "I participate": "I participate",
  "I want to allow people to participate without an account.": "I want to allow people to participate without an account.",
  "I want to approve every participation request": "I want to approve every participation request",
  "I want to manage the registration on Mobilizon": "I want to manage the registration on Mobilizon",
  "I want to manage the registration with an external provider": "I want to manage the registration with an external provider",
  "I've been mentionned in a comment under an event": "I've been mentionned in a comment under an event",
  "I've been mentionned in a conversation": "I've been mentionned in a conversation",
  "I've been mentionned in a group discussion": "I've been mentionned in a group discussion",
  "I've clicked on X, then on Y": "I've clicked on X, then on Y",
  "ICS feed for events": "ICS feed for events",
  "ICS/WebCal Feed": "ICS/WebCal Feed",
  "ICS/WebCal feed for this search":"ICS/WebCal feed for this search",
  "IP Address": "IP Address",
  "Identities": "Identities",
  "Identity {displayName} created": "Identity {displayName} created",
  "Identity {displayName} deleted": "Identity {displayName} deleted",
  "Identity {displayName} updated": "Identity {displayName} updated",
  "If allowed by organizer": "If allowed by organizer",
  "If an account with this email exists, we just sent another confirmation email to {email}": "If an account with this email exists, we just sent another confirmation email to {email}",
  "If the event is published by your organization, you should press \"change\" to attribute the event to your organization group page. The group page gathers events, activities and posts and can have followers. If your organization doesn't have a group page yet, you can create it now.": "If the event is published by your organization, you should press \"change\" to attribute the event to your organization group page. The group page gathers events, activities and posts and can have followers. If your organization doesn't have a group page yet, you can create it now.",
  "If this identity is the only administrator of some groups, you need to delete them before being able to delete this identity.": "If this identity is the only administrator of some groups, you need to delete them before being able to delete this identity.",
  "If you are being asked for your federated indentity, it's composed of your username and your instance. For instance, the federated identity for your first profile is:": "If you are being asked for your federated indentity, it's composed of your username and your instance. For instance, the federated identity for your first profile is:",
  "If you have opted for manual validation of participants, Mobilizon will send you an email to inform you of new participations to be processed. You can choose the frequency of these notifications below.": "If you have opted for manual validation of participants, Mobilizon will send you an email to inform you of new participations to be processed. You can choose the frequency of these notifications below.",
  "If you want, you may send a message to the event organizer here.": "If you want, you may send a message to the event organizer here.",
  "Ignore": "Ignore",
  "Illustration picture for \u201c{category}\u201d by {author} on {source} ({license})": "Illustration picture for \u201c{category}\u201d by {author} on {source} ({license})",
  "In person": "In person",
  "In the following context, an application is a software, either provided by the Mobilizon team or by a 3rd-party, used to interact with your instance.": "In the following context, an application is a software, either provided by the Mobilizon team or by a 3rd-party, used to interact with your instance.",
  "In the past": "In the past",
  "In this instance's network": "In this instance's network",
  "Increase": "Increase",
  "Increasing creation date": "Increasing creation date",
  "Increasing number of members": "Increasing number of members",
  "Informations": "Informations",
  "Instance Long Description": "Instance Long Description",
  "Instance Name": "Instance Name",
  "Instance Privacy Policy Source": "Instance Privacy Policy Source",
  "Instance Privacy Policy URL": "Instance Privacy Policy URL",
  "Instance Privacy Policy": "Instance Privacy Policy",
  "Instance Rules": "Instance Rules",
  "Instance Short Description": "Instance Short Description",
  "Instance Slogan": "Instance Slogan",
  "Instance Terms Source": "Instance Terms Source",
  "Instance Terms URL": "Instance Terms URL",
  "Instance Terms": "Instance Terms",
  "Instance administrator": "Instance administrator",
  "Instance configuration": "Instance configuration",
  "Instance feeds": "Instance feeds",
  "Instance languages": "Instance languages",
  "Instance rules": "Instance rules",
  "Instance settings": "Instance settings",
  "Instance": "Instance",
  "Instances following you": "Instances following you",
  "Instances you follow": "Instances you follow",
  "Instances": "Instances",
  "Integrate this event with 3rd-party tools and show metadata for the event.": "Integrate this event with 3rd-party tools and show metadata for the event.",
  "Interact with a remote content": "Interact with a remote content",
  "Interact": "Interact",
  "Invitation URL":"Invitation URL",
  "Invitation links": "Invitation links",
  "Invitations to join the group": "Invitations to join the group",
  "Invitations":"Invitations",
  "Invite a new member": "Invite a new member",
  "Invite link": "Invite link",
  "Invite member": "Invite member",
  "Invited": "Invited",
  "It is possible that the content is not accessible on this instance, because this instance has blocked the profiles or groups behind this content.": "It is possible that the content is not accessible on this instance, because this instance has blocked the profiles or groups behind this content.",
  "Italic": "Italic",
  "Jitsi Meet": "Jitsi Meet",
  "Join <b>{instance}</b>, a Mobilizon instance": "Join <b>{instance}</b>, a Mobilizon instance",
  "Join a group": "Join a group",
  "Join group {group}": "Join group {group}",
  "Join group": "Join group",
  "Join my group":"Join my group",
  "Join {instance}, a Mobilizon instance": "Join {instance}, a Mobilizon instance",
  "Join": "Join",
  "Keep the entire conversation about a specific topic together on a single page.": "Keep the entire conversation about a specific topic together on a single page.",
  "Key words": "Key words",
  "Keyword, event title, group name, etc.": "Keyword, event title, group name, etc.",
  "Label": "Label",
  "Language": "Language",
  "Languages": "Languages",
  "Last IP adress": "Last IP adress",
  "Last event activity": "Last event activity",
  "Last group created": "Last group created",
  "Last published event": "Last published event",
  "Last published events": "Last published events",
  "Last seen on": "Last seen on",
  "Last sign-in": "Last sign-in",
  "Last used on {last_used_date}": "Last used on {last_used_date}",
  "Last week": "Last week",
  "Latest posts": "Latest posts",
  "Learn more about Mobilizon": "Learn more about Mobilizon",
  "Learn more about {instance}": "Learn more about {instance}",
  "Learn more": "Learn more",
  "Least recently published": "Least recently published",
  "Leave event": "Leave event",
  "Leave group": "Leave group",
  "Leave": "Leave",
  "Leaving event \"{title}\"": "Leaving event \"{title}\"",
  "Legal": "Legal",
  "Let's define a few settings": "Let's define a few settings",
  "License": "License",
  "Light": "Light",
  "Limited number of places": "Limited number of places",
  "List of conversations": "List of conversations",
  "List title": "List title",
  "List": "List",
  "Live": "Live",
  "Load more activities": "Load more activities",
  "Load more": "Load more",
  "Loading comments\u2026": "Loading comments\u2026",
  "Loading map": "Loading map",
  "Loading search results...": "Loading search results...",
  "Loading\u2026": "Loading\u2026",
  "Local time ({timezone})": "Local time ({timezone})",
  "Local times ({timezone})": "Local times ({timezone})",
  "Local": "Local",
  "Locality": "Locality",
  "Location": "Location",
  "Log in": "Log in",
  "Log out": "Log out",
  "Login on Mobilizon!": "Login on Mobilizon!",
  "Login on {instance}": "Login on {instance}",
  "Login status": "Login status",
  "Login": "Login",
  "Logo of the instance. Defaults to the upstream Mobilizon logo.": "Logo of the instance. Defaults to the upstream Mobilizon logo.",
  "Logo": "Logo",
  "Main languages you/your moderators speak": "Main languages you/your moderators speak",
  "Make sure that all words are spelled correctly.": "Make sure that all words are spelled correctly.",
  "Manage activity settings": "Manage activity settings",
  "Manage event participations": "Manage event participations",
  "Manage group members": "Manage group members",
  "Manage group memberships": "Manage group memberships",
  "Manage participations": "Manage participations",
  "Manage push notification settings": "Manage push notification settings",
  "Manually approve new followers": "Manually approve new followers",
  "Manually enter address": "Manually enter address",
  "Manually invite new members": "Manually invite new members",
  "Map": "Map",
  "Mark as resolved": "Mark as resolved",
  "Maybe the content was removed by the author or a moderator": "Maybe the content was removed by the author or a moderator",
  "Member invitation by username":"Member invitation by username",
  "Member": "Member",
  "Members can see events' participants": "Members can see events' participants",
  "Members will also access private sections like discussions, resources and restricted posts.": "Members will also access private sections like discussions, resources and restricted posts.",
  "Members": "Members",
  "Members-only post": "Members-only post",
  "Membership requests will be approved by a group moderator": "Membership requests will be approved by a group moderator",
  "Memberships": "Memberships",
  "Mentions": "Mentions",
  "Message body": "Message body",
  "Message": "Message",
  "Microsoft Teams": "Microsoft Teams",
  "Mobilizon is a federated network. You can interact with this event from a different server.": "Mobilizon is a federated network. You can interact with this event from a different server.",
  "Mobilizon is a federated software, meaning you can interact - depending on your admin's federation settings - with content from other instances, such as joining groups or events that were created elsewhere.": "Mobilizon is a federated software, meaning you can interact - depending on your admin federation settings - with content from other instances, such as joining groups or events that were created elsewhere.",
  "Mobilizon is a tool that helps you <b>find, create and organise events</b>.": "Mobilizon is a tool that helps you <b>find, create and organise events</b>.",
  "Mobilizon is a tool that helps you {find_create_organize_events}.": "Mobilizon is a tool that helps you {find_create_organize_events}.",
  "Mobilizon is not a giant platform, but a <b>multitude of interconnected Mobilizon websites</b>.": "Mobilizon is not a giant platform, but a <b>multitude of interconnected Mobilizon websites</b>.",
  "Mobilizon is not a giant platform, but a {multitude_of_interconnected_mobilizon_websites}.": "Mobilizon is not a giant platform, but a {multitude_of_interconnected_mobilizon_websites}.",
  "Mobilizon software": "Mobilizon software",
  "Mobilizon uses a system of profiles to compartiment your activities. You will be able to create as many profiles as you want.": "Mobilizon uses a system of profiles to compartiment your activities. You will be able to create as many profiles as you want.",
  "Mobilizon version": "Mobilizon version",
  "Mobilizon will send you an email when the events you are attending have important changes: date and time, address, confirmation or cancellation, etc.": "Mobilizon will send you an email when the events you are attending have important changes: date and time, address, confirmation or cancellation, etc.",
  "Mobilizon": "Mobilizon",
  "Moderate new members": "Moderate new members",
  "Moderated comments (shown after approval)": "Moderated comments (shown after approval)",
  "Moderation log": "Moderation log",
  "Moderation logs": "Moderation logs",
  "Moderation": "Moderation",
  "Moderator": "Moderator",
  "Modify all of your account's data": "Modify all of your account's data",
  "Month": "Month",
  "More options": "More options",
  "Most recently published": "Most recently published",
  "Move \"{resourceName}\"": "Move \"{resourceName}\"",
  "Move resource to the root folder": "Move resource to the root folder",
  "Move resource to {folder}": "Move resource to {folder}",
  "Move": "Move",
  "My account": "My account",
  "My events": "My events",
  "My federated identity ends in {domain}": "My federated identity ends in {domain}",
  "My groups": "My groups",
  "My identities": "My identities",
  "NOTE! The default terms have not been checked over by a lawyer and thus are unlikely to provide full legal protection for all situations for an instance admin using them. They are also not specific to all countries and jurisdictions. If you are unsure, please check with a lawyer.": "NOTE! The default terms have not been checked over by a lawyer and thus are unlikely to provide full legal protection for all situations for an instance admin using them. They are also not specific to all countries and jurisdictions. If you are unsure, please check with a lawyer.",
  "Name": "Name",
  "Navigated to {pageTitle}": "Navigated to {pageTitle}",
  "Never used": "Never used",
  "New announcement": "New announcement",
  "New discussion": "New discussion",
  "New email": "New email",
  "New folder": "New folder",
  "New invitation": "New invitation",
  "New link": "New link",
  "New members": "New members",
  "New note": "New note",
  "New password": "New password",
  "New post": "New post",
  "New private message": "New private message",
  "New profile": "New profile",
  "Next month": "Next month",
  "Next page": "Next page",
  "Next week": "Next week",
  "Next": "Next",
  "No about content yet": "No about content yet",
  "No activities found": "No activities found",
  "No address defined": "No address defined",
  "No apps authorized yet": "No apps authorized yet",
  "No categories with public upcoming events on this instance were found.": "No categories with public upcoming events on this instance were found.",
  "No closed reports yet": "No closed reports yet",
  "No comment": "No comment",
  "No comments yet": "No comments yet",
  "No content found": "No content found",
  "No discussions yet": "No discussions yet",
  "No end date": "No end date",
  "No event found at this address": "No event found at this address",
  "No events found for {search}": "No events found for {search}",
  "No events found nearby {position}. Try removing your position to see all events!": "No events found nearby {position}. Try removing your position to see all events!",
  "No events found": "No events found",
  "No follower matches the filters": "No follower matches the filters",
  "No group found": "No group found",
  "No group matches the filters": "No group matches the filters",
  "No group member found": "No group member found",
  "No groups found for {search}": "No groups found for {search}",
  "No groups found": "No groups found",
  "No information": "No information",
  "No instance follows your instance yet.": "No instance follows your instance yet.",
  "No instance found.": "No instance found.",
  "No instance to approve|Approve instance|Approve {number} instances": "No instance to approve|Approve instance|Approve {number} instances",
  "No instance to reject|Reject instance|Reject {number} instances": "No instance to reject|Reject instance|Reject {number} instances",
  "No instance to remove|Remove instance|Remove {number} instances": "No instances to remove|Remove instance|Remove {number} instances",
  "No instances match this filter. Try resetting filter fields?": "No instances match this filter. Try resetting filter fields?",
  "No invitation yet. Create a new invitation with the button \"New invitation\".":"No invitation yet. Create a new invitation with the button \"New invitation\".",
  "No languages found": "No languages found",
  "No location yet": "No location yet",
  "No member matches the filters": "No member matches the filters",
  "No members found": "No members found",
  "No memberships found": "No memberships found",
  "No message": "No message",
  "No moderation logs yet": "No moderation logs yet",
  "No more activity to display.": "No more activity to display.",
  "No one is participating|One person participating|{going} people participating": "No one is participating|One person participating|{going} people participating",
  "No open reports yet": "No open reports yet",
  "No organized events found": "No organized events found",
  "No organized events listed": "No organized events listed",
  "No participant matches the filters": "No participant matches the filters",
  "No participant to approve|Approve participant|Approve {number} participants": "No participant to approve|Approve participant|Approve {number} participants",
  "No participant to reject|Reject participant|Reject {number} participants": "No participant to reject|Reject participant|Reject {number} participants",
  "No participations listed": "No participations listed",
  "No posts found": "No posts found",
  "No posts yet": "No posts yet",
  "No profile matches the filters": "No profile matches the filters",
  "No public upcoming activities": "No public upcoming activities",
  "No public upcoming events": "No public upcoming events",
  "No resolved reports yet": "No resolved reports yet",
  "No resources in this folder": "No resources in this folder",
  "No resources selected": "No resources selected|One resources selected|{count} resources selected",
  "No resources yet": "No resources yet",
  "No results for \"{queryText}\"": "No results for \"{queryText}\"",
  "No results for {search}": "No results for {search}",
  "No results found for {search}": "No results found for {search}",
  "No results found": "No results found",
  "No rules defined yet.": "No rules defined yet.",
  "No user matches the filter": "No user matches the filter",
  "No user matches the filters": "No user matches the filters",
  "None": "None",
  "Not accessible with a wheelchair": "Not accessible with a wheelchair",
  "Not approved": "Not approved",
  "Not confirmed": "Not confirmed",
  "Notes": "Notes",
  "Notification before the event": "Notification before the event",
  "Notification on the day of the event": "Notification on the day of the event",
  "Notification settings": "Notification settings",
  "Notifications for manually approved participations to an event": "Notifications for manually approved participations to an event",
  "Notifications": "Notifications",
  "Notify participants": "Notify participants",
  "Notify the user of the change": "Notify the user of the change",
  "Now, create your first profile:": "Now, create your first profile:",
  "Number of members": "Number of members",
  "Number of places": "Number of places",
  "OK": "OK",
  "Old password": "Old password",
  "On foot": "On foot",
  "On the Fediverse": "On the Fediverse",
  "On {date} ending at {endTime}": "On {date} ending at {endTime}",
  "On {date} from {startTime} to {endTime}": "On {date} from {startTime} to {endTime}",
  "On {date} starting at {startTime}": "On {date} starting at {startTime}",
  "On {date}": "On {date}",
  "On {instance} and other federated instances": "On {instance} and other federated instances",
  "Online events": "Online events",
  "Online ticketing": "Online ticketing",
  "Online upcoming events": "Online upcoming events",
  "Online": "Online",
  "Only Mobilizon instances can be followed": "",
  "Only accessible through link (private)": "Only accessible through link (private)",
  "Only accessible through link": "Only accessible through link",
  "Only accessible to members of the group": "Only accessible to members of the group",
  "Only alphanumeric lowercased characters and underscores are supported.": "Only alphanumeric lowercased characters and underscores are supported.",
  "Only group members can access discussions": "Only group members can access discussions",
  "Only group moderators can create, edit and delete events.": "Only group moderators can create, edit and delete events.",
  "Only group moderators can create, edit and delete posts.": "Only group moderators can create, edit and delete posts.",
  "Only instances with an application actor can be followed": "Only instances with an application actor can be followed",
  "Only registered users may fetch remote events from their URL.": "Only registered users may fetch remote events from their URL.",
  "Open a topic on our forum": "Open a topic on our forum",
  "Open an issue on our bug tracker (advanced users)": "Open an issue on our bug tracker (advanced users)",
  "Open conversations": "Open conversations",
  "Open main menu": "Open main menu",
  "Open user menu": "Open user menu",
  "Open": "Open",
  "Opened reports": "Opened reports",
  "Options": "Options",
  "Or": "Or",
  "Ordered list": "Ordered list",
  "Organized by {name}": "Organized by {name}",
  "Organized by": "Organized by",
  "Organized events": "Organized events",
  "Organized": "Organized",
  "Organizer notifications": "Organizer notifications",
  "Organizer": "Organizer",
  "Organizers": "Organizers",
  "Other actions": "Other actions",
  "Other notification options:": "Other notification options:",
  "Other software may also support this.": "Other software may also support this.",
  "Other users with the same IP address": "Other users with the same IP address",
  "Other users with the same email domain": "Other users with the same email domain",
  "Other": "Other",
  "Others":"Others",
  "Otherwise this identity will just be removed from the group administrators.": "Otherwise this identity will just be removed from the group administrators.",
  "Owncast": "Owncast",
  "Page limited to my group (asks for auth)": "Page limited to my group (asks for auth)",
  "Page not found": "Page not found",
  "Page": "Page",
  "Parent folder": "Parent folder",
  "Partially accessible with a wheelchair": "Partially accessible with a wheelchair",
  "Participant": "Participant",
  "Participants to {eventTitle}": "Participants to {eventTitle}",
  "Participants": "Participants",
  "Participate using your email address": "Participate using your email address",
  "Participate": "Participate",
  "Participation approval": "Participation approval",
  "Participation confirmation": "Participation confirmation",
  "Participation notifications": "Participation notifications",
  "Participation requested!": "Participation requested!",
  "Participation with account": "Participation with account",
  "Participation without account": "Participation without account",
  "Participations": "Participations",
  "Password (confirmation)": "Password (confirmation)",
  "Password and confirmation password must be identical.": "Password and confirmation password must be identical.",
  "Password reset": "Password reset",
  "Password": "Password",
  "Past activities": "Passed activities",
  "Past events": "Passed events",
  "PeerTube live": "PeerTube live",
  "PeerTube replay": "PeerTube replay",
  "Pending": "Pending",
  "Permission": "Permission",
  "Personal feeds": "Personal feeds",
  "Photo by {author} on {source}": "Photo by {author} on {source}",
  "Pick a profile or a group": "Pick a profile or a group",
  "Pick an identity": "Pick an identity",
  "Pick an instance": "Pick an instance",
  "Pick": "Pick",
  "Pictures": "Pictures",
  "Please add as many details as possible to help identify the problem.": "Please add as many details as possible to help identify the problem.",
  "Please check your spam folder if you didn't receive the email.": "Please check your spam folder if you didn't receive the email.",
  "Please contact this instance's Mobilizon admin if you think this is a mistake.": "Please contact this instance's Mobilizon admin if you think this is a mistake.",
  "Please do not use it in any real way.": "Please do not use it in any real way.",
  "Please enter your password to confirm this action.": "Please enter your password to confirm this action.",
  "Please make sure the address is correct and that the page hasn't been moved.": "Please make sure the address is correct and that the page hasn't been moved.",
  "Please read the {fullRules} published by {instance}'s administrators.": "Please read the {fullRules} published by {instance}'s administrators.",
  "Policies": "Policies",
  "Popular groups close to you": "Popular groups close to you",
  "Popular groups nearby {position}": "Popular groups nearby {position}",
  "Post URL": "Post URL",
  "Post a comment": "Post a comment",
  "Post a reply": "Post a reply",
  "Post body": "Post body",
  "Post comments": "Post comments",
  "Post {eventTitle} reported": "Post {eventTitle} reported",
  "Post": "Post",
  "Postal Code": "Postal Code",
  "Posts": "Posts",
  "Powered by Mobilizon": "Powered by Mobilizon",
  "Powered by {mobilizon}. \u00a9 2018 - {date} The Mobilizon Contributors - Made with the financial support of {contributors}.": "Powered by {mobilizon}. \u00a9 2018 - {date} The Mobilizon Contributors - Made with the financial support of {contributors}.",
  "Preferences": "Preferences",
  "Previous email": "Previous email",
  "Previous month": "Previous month",
  "Previous page": "Previous page",
  "Previous": "Previous",
  "Price sheet": "Price sheet",
  "Primary Color": "Primary Color",
  "Privacy Policy": "Privacy Policy",
  "Privacy policy": "Privacy policy",
  "Privacy": "Privacy",
  "Private event": "Private event",
  "Private feeds": "Private feeds",
  "Profile feeds": "Profile feeds",
  "Profile suspended and report resolved": "Profile suspended and report resolved",
  "Profile": "Profile",
  "Profiles and federation": "Profiles and federation",
  "Profiles": "Profiles",
  "Promote": "Promote",
  "Public RSS/Atom Feed": "Public RSS/Atom Feed",
  "Public comment moderation": "Public comment moderation",
  "Public event": "Public event",
  "Public feeds": "Public feeds",
  "Public iCal Feed": "Public iCal Feed",
  "Public preview": "Public preview",
  "Public": "Public",
  "Publication date": "Publication date",
  "Publish as individual": "Publish as individual",
  "Publish events": "Publish events",
  "Publish from a group": "Publish from a group",
  "Publish group posts": "Publish group posts",
  "Publish": "Publish",
  "Published by {name}": "Published by {name}",
  "Published by": "Published by",
  "Published events with <b>{comments}</b> comments and <b>{participations}</b> confirmed participations": "Published events with <b>{comments}</b> comments and <b>{participations}</b> confirmed participations",
  "Published events with {comments} comments and {participations} confirmed participations": "Published events with {comments} comments and {participations} confirmed participations",
  "Push": "Push",
  "Quote": "Quote",
  "RSS/Atom Feed": "RSS/Atom Feed",
  "RSS/Atom feed for this search":"RSS/Atom feed for this search",
  "Radius": "Radius",
  "Read all of your account's data": "Read all of your account's data",
  "Read user activity settings": "Read user activity settings",
  "Read user media": "Read user media",
  "Read user memberships": "Read user memberships",
  "Read user participations": "Read user participations",
  "Read user settings": "Read user settings",
  "Recap every week": "Recap every week",
  "Receive one email for each activity": "Receive one email for each activity",
  "Receive one email per request": "Receive one email per request",
  "Redirecting in progress\u2026": "Redirecting in progress\u2026",
  "Redirecting to Mobilizon": "Redirecting to Mobilizon",
  "Redirecting to content\u2026": "Redirecting to content\u2026",
  "Redo": "Redo",
  "Refresh profile": "Refresh profile",
  "Regenerate new links": "Regenerate new links",
  "Region": "Region",
  "Register an account on {instanceName}!": "Register an account on {instanceName}!",
  "Register on this instance": "Register on this instance",
  "Register": "Register",
  "Registration is allowed, anyone can register.": "Registration is allowed, anyone can register.",
  "Registration is closed.": "Registration is closed.",
  "Registration is currently closed.": "Registration is currently closed.",
  "Registration is moderated, new user must be validated.": "Registration is moderated, new user must be validated.",
  "Registration is subject to moderation, indicate your motivation.": "Registration is subject to moderation, indicate your motivation.",
  "Registrations are restricted by allowlisting.": "Registrations are restricted by allowlisting.",
  "Registrations": "Registrations",
  "Reject follow": "Reject follow",
  "Reject member": "Reject member",
  "Reject": "Reject",
  "Rejected": "Rejected",
  "Remember my participation in this browser": "Remember my participation in this browser",
  "Remove link": "Remove link",
  "Remove uploaded media": "Remove uploaded media",
  "Remove": "Remove",
  "Rename resource": "Rename resource",
  "Rename": "Rename",
  "Reopen": "Reopen",
  "Replay": "Replay",
  "Reply": "Reply",
  "Report #{reportNumber}": "Report #{reportNumber}",
  "Report as ham": "Report as ham",
  "Report as spam": "Report as spam",
  "Report as undetected spam": "Report as undetected spam",
  "Report reason": "Report reason",
  "Report status": "Report status",
  "Report this comment": "Report this comment",
  "Report this event": "Report this event",
  "Report this group": "Report this group",
  "Report this post": "Report this post",
  "Report": "Report",
  "Reported at": "Reported at",
  "Reported by an unknown actor": "Reported by an unknown actor",
  "Reported by someone anonymously": "Reported by someone anonymously",
  "Reported by someone on {domain}": "Reported by someone on {domain}",
  "Reported by {reporter}": "Reported by {reporter}",
  "Reported by": "Reported by",
  "Reported content": "Reported content",
  "Reported group": "Reported group",
  "Reported identity": "Reported identity",
  "Reported": "Reported",
  "Reports list": "Reports list",
  "Reports": "Reports",
  "Request for participation confirmation sent": "Request for participation confirmation sent",
  "Resend confirmation email": "Resend confirmation email",
  "Resent confirmation email": "Resent confirmation email",
  "Reset filters": "Reset filters",
  "Reset my password": "Reset my password",
  "Reset password": "Reset password",
  "Reset your password": "Reset your password",
  "Reset": "Reset",
  "Resolved": "Resolved",
  "Resource provided is not an URL": "Resource provided is not an URL",
  "Resources": "Resources",
  "Restricted": "Restricted",
  "Return to the event page": "Return to the event page",
  "Return to the group page": "Return to the group page",
  "Revoke": "Revoke",
  "Right now": "Right now",
  "Role": "Role",
  "Rules": "Rules",
  "SSL and it's successor TLS are encryption technologies to secure data communications when using the service. You can recognize an encrypted connection in your browser's address line when the URL begins with {https} and the lock icon is displayed in your browser's address bar.": "SSL and it's successor TLS are encryption technologies to secure data communications when using the service. You can recognize an encrypted connection in your browser's address line when the URL begins with {https} and the lock icon is displayed in your browser's address bar.",
  "SSL/TLS": "SSL/TLS",
  "Save draft": "Save draft",
  "Save instance settings": "Save instance settings",
  "Save": "Save",
  "Schedule": "Schedule",
  "Search events, groups, etc.": "Search events, groups, etc.",
  "Search target": "Search target",
  "Search": "Search",
  "Searching\u2026": "Searching\u2026",
  "Secondary Color": "Secondary Color",
  "Select a category": "Select a category",
  "Select a language": "Select a language",
  "Select a radius": "Select a radius",
  "Select a timezone": "Select a timezone",
  "Select all": "Select all",
  "Select all resources": "Select all resources",
  "Select distance": "Select distance",
  "Select languages": "Select languages",
  "Select the activities for which you wish to receive an email or a push notification.": "Select the activities for which you wish to receive an email or a push notification.",
  "Select this resource": "Select this resource",
  "Send email": "Send email",
  "Send feedback": "Send feedback",
  "Send notification e-mails": "Send notification e-mails",
  "Send password reset": "Send password reset",
  "Send the confirmation email again": "Send the confirmation email again",
  "Send the report": "Send the report",
  "Send": "Send",
  "Sent to {count} participants": "Sent to no participants|Sent to one participant|Sent to {count} participants",
  "Set an URL to a page with your own privacy policy.": "Set an URL to a page with your own privacy policy.",
  "Set an URL to a page with your own terms.": "Set an URL to a page with your own terms.",
  "Settings": "Settings",
  "Share link":"Share link",
  "Share this event": "Share this event",
  "Share this group invitation link":"Share this group invitation link",
  "Share this group": "Share this group",
  "Share this post": "Share this post",
  "Share": "Share",
  "Short bio": "Short bio",
  "Show filters": "Show filters",
  "Show map": "Show map",
  "Show me where I am": "Show me where I am",
  "Show remaining number of places": "Show remaining number of places",
  "Show the time when the event begins": "Show the time when the event begins",
  "Show the time when the event ends": "Show the time when the event ends",
  "Showing events before": "Showing events before",
  "Showing events starting on": "Showing events starting on",
  "Showing participants": "Showing participants",
  "Sign Language": "Sign Language",
  "Sign in with": "Sign in with",
  "Sign up": "Sign up",
  "Since you are a new member, private content can take a few minutes to appear.": "Since you are a new member, private content can take a few minutes to appear.",
  "Skip to main content": "Skip to main content",
  "Smoke free": "Smoke free",
  "Smoking allowed": "Smoking allowed",
  "Social": "Social",
  "Software details: {software_details}": "Software details: {software_details}",
  "Some terms, technical or otherwise, used in the text below may cover concepts that are difficult to grasp. We have provided a glossary here to help you understand them better:": "Some terms, technical or otherwise, used in the text below may cover concepts that are difficult to grasp. We have provided a glossary here to help you understand them better:",
  "Sorry, we wen't able to save your feedback. Don't worry, we'll try to fix this issue anyway.": "Sorry, we wen't able to save your feedback. Don't worry, we'll try to fix this issue anyway.",
  "Sort by events": "Sort by events",
  "Sort by groups": "Sort by groups",
  "Sort by": "Sort by",
  "Starts on\u2026": "Starts on\u2026",
  "Status": "Status",
  "Statuses": "Statuses",
  "Stop following instance": "Stop following instance",
  "Street": "Street",
  "Submit to Akismet": "Submit to Akismet",
  "Submit": "Submit",
  "Subscribe" : "Subscribe",
  "Subtitles": "Subtitles",
  "Suggestions:": "Suggestions:",
  "Suspend group": "Suspend group",
  "Suspend the profile": "Suspend the profile",
  "Suspend the profile?": "Suspend the profile?",
  "Suspend": "Suspend",
  "Suspended": "Suspended",
  "Tag search": "Tag search",
  "Task lists": "Task lists",
  "Technical details": "Technical details",
  "Tentative": "Tentative",
  "Tentative: Will be confirmed later": "Tentative: Will be confirmed later",
  "Terms of service": "Terms of service",
  "Terms": "Terms",
  "Text": "Text",
  "Thanks a lot, your feedback was submitted!": "Thanks a lot, your feedback was submitted!",
  "That you follow or of which you are a member": "That you follow or of which you are a member",
  "The Big Blue Button video teleconference URL": "The Big Blue Button video teleconference URL",
  "The Google Meet video teleconference URL": "The Google Meet video teleconference URL",
  "The Jitsi Meet video teleconference URL": "The Jitsi Meet video teleconference URL",
  "The Microsoft Teams video teleconference URL": "The Microsoft Teams video teleconference URL",
  "The URL of a pad where notes are being taken collaboratively": "The URL of a pad where notes are being taken collaboratively",
  "The URL of a poll where the choice for the event date is happening": "The URL of a poll where the choice for the event date is happening",
  "The URL where the event can be watched live": "The URL where the event can be watched live",
  "The URL where the event live can be watched again after it has ended": "The URL where the event live can be watched again after it has ended",
  "The Zoom video teleconference URL": "The Zoom video teleconference URL",
  "The account's email address was changed. Check your emails to verify it.": "The account's email address was changed. Check your emails to verify it.",
  "The actual number of participants may differ, as this event is hosted on another instance.": "The actual number of participants may differ, as this event is hosted on another instance.",
  "The calc will be created on {service}": "The calc will be created on {service}",
  "The content came from another server. Transfer an anonymous copy of the report?": "The content came from another server. Transfer an anonymous copy of the report?",
  "The device code is incorrect or no longer valid.": "The device code is incorrect or no longer valid.",
  "The draft event has been updated": "The draft event has been updated",
  "The event has a sign language interpreter": "The event has a sign language interpreter",
  "The event has been created as a draft": "The event has been created as a draft",
  "The event has been published": "The event has been published",
  "The event has been updated and published": "The event has been updated and published",
  "The event has been updated": "The event has been updated",
  "The event hasn't got a sign language interpreter": "The event hasn't got a sign language interpreter",
  "The event is fully online": "The event is fully online",
  "The event live video contains subtitles": "The event live video contains subtitles",
  "The event live video does not contain subtitles": "The event live video does not contain subtitles",
  "The event organiser has chosen to validate manually participations. Do you want to add a little note to explain why you want to participate to this event?": "The event organiser has chosen to validate manually participations. Do you want to add a little note to explain why you want to participate to this event?",
  "The event organizer didn't add any description.": "The event organizer didn't add any description.",
  "The event organizer manually approves participations. Since you've chosen to participate without an account, please explain why you want to participate to this event.": "The event organizer manually approves participations. Since you've chosen to participate without an account, please explain why you want to participate to this event.",
  "The event title will be ellipsed.": "The event title will be ellipsed.",
  "The event will show as published by this group.": "The event will show as published by this group.",
  "The event will show as published by this profile.": "The event will show as published by this profile.",
  "The event will show as published by your personal profile.": "The event will show as published by your personal profile.",
  "The event {event} was created by {profile}.": "The event {event} was created by {profile}.",
  "The event {event} was deleted by {profile}.": "The event {event} was deleted by {profile}.",
  "The event {event} was updated by {profile}.": "The event {event} was updated by {profile}.",
  "The events you created are not shown here.": "The events you created are not shown here.",
  "The following participants are groups, which means group members are able to reply to this conversation:": "The following participants are groups, which means group members are able to reply to this conversation:",
  "The following user's profiles will be deleted, with all their data:": "The following user's profiles will be deleted, with all their data:",
  "The geolocation prompt was denied.": "The geolocation prompt was denied.",
  "The group can now be joined by anyone, but new members need to be approved by an administrator.": "The group can now be joined by anyone, but new members need to be approved by an administrator.",
  "The group can now be joined by anyone.": "The group can now be joined by anyone.",
  "The group can now only be joined with an invite.": "The group can now only be joined with an invite.",
  "The group will be publicly listed in search results and may be suggested in the explore section. Only public informations will be shown on it's page.": "The group will be publicly listed in search results and may be suggested in the explore section. Only public informations will be shown on it's page.",
  "The group's avatar was changed.": "The group's avatar was changed.",
  "The group's banner was changed.": "The group's banner was changed.",
  "The group's physical address was changed.": "The group's physical address was changed.",
  "The group's short description was changed.": "The group's short description was changed.",
  "The instance administrator is the person or entity that runs this Mobilizon instance.": "The instance administrator is the person or entity that runs this Mobilizon instance.",
  "The member was approved": "The member was approved",
  "The member was removed from the group {group}": "The member was removed from the group {group}",
  "The membership request from {profile} was rejected": "The membership request from {profile} was rejected",
  "The only way for your group to get new members is if an admininistrator invites them.": "The only way for your group to get new members is if an admininistrator invites them.",
  "The organiser has chosen to close comments.": "The organiser has chosen to close comments.",
  "The pad will be created on {service}": "The pad will be created on {service}",
  "The page you're looking for doesn't exist.": "The page you're looking for doesn't exist.",
  "The password was successfully changed": "The password was successfully changed",
  "The post {post} was created by {profile}.": "The post {post} was created by {profile}.",
  "The post {post} was deleted by {profile}.": "The post {post} was deleted by {profile}.",
  "The post {post} was updated by {profile}.": "The post {post} was updated by {profile}.",
  "The provided application was not found.": "The provided application was not found.",
  "The report contents (eventual comments and event) and the reported profile details will be transmitted to Akismet.": "The report contents (eventual comments and event) and the reported profile details will be transmitted to Akismet.",
  "The report will be sent to the moderators of your instance. You can explain why you report this content below.": "The report will be sent to the moderators of your instance. You can explain why you report this content below.",
  "The selected picture is too heavy. You need to select a file smaller than {size}.": "The selected picture is too heavy. You need to select a file smaller than {size}.",
  "The technical details of the error can help developers solve the problem more easily. Please add them to your feedback.": "The technical details of the error can help developers solve the problem more easily. Please add them to your feedback.",
  "The user has been banned": "The user has been banned",
  "The videoconference will be created on {service}": "The videoconference will be created on {service}",
  "The {default_privacy_policy} will be used. They will be translated in the user's language.": "The {default_privacy_policy} will be used. They will be translated in the user's language.",
  "The {default_terms} will be used. They will be translated in the user's language.": "The {default_terms} will be used. They will be translated in the user's language.",
  "Theme": "Theme",
  "There are {participants} participants.": "There are {participants} participants.",
  "There is no activity yet. Start doing some things to see activity appear here.": "There is no activity yet. Start doing some things to see activity appear here.",
  "There will be no way to recover your data.": "There will be no way to recover your data.",
  "There will be no way to restore the profile's data!": "There will be no way to restore the profile's data!",
  "There will be no way to restore the user's data!": "There will be no way to restore the user's data!",
  "There's no announcements yet": "There's no announcements yet",
  "There's no conversations yet": "There are no conversations yet",
  "There's no discussions yet": "There's no discussions yet",
  "These apps can access your account through the API. If you see here apps that you don't recognize, that don't work as expected or that you don't use anymore, you can revoke their access.": "These apps can access your account through the API. If you see here apps that you don't recognize, that don't work as expected or that you don't use anymore, you can revoke their access.",
  "These events may interest you": "These events may interest you",
  "These feeds contain event data for the events for which any of your profiles is a participant or creator. You should keep these private. You can find feeds for specific profiles on each profile edition page.": "These feeds contain event data for the events for which any of your profiles is a participant or creator. You should keep these private. You can find feeds for specific profiles on each profile edition page.",
  "These feeds contain event data for the events for which this specific profile is a participant or creator. You should keep these private. You can find feeds for all of your profiles into your notification settings.": "These feeds contain event data for the events for which this specific profile is a participant or creator. You should keep these private. You can find feeds for all of your profiles into your notification settings.",
  "They asked to follow us":"They asked to follow us",
  "They follow us":"They follow us",
  "This Mobilizon instance and this event organizer allows anonymous participations, but requires validation through email confirmation.": "This Mobilizon instance and this event organizer allows anonymous participations, but requires validation through email confirmation.",
  "This URL doesn't seem to be valid": "This URL doesn't seem to be valid",
  "This URL is not supported": "This URL is not supported",
  "This announcement will be send to all participants with the statuses selected below. They will not be allowed to reply to your announcement, but they can create a new conversation with you.": "This announcement will be send to all participants with the statuses selected below. They will not be allowed to reply to your announcement, but they can create a new conversation with you.",
  "This application asks for the following permissions:": "This application asks for the following permissions:",
  "This application didn't ask for known permissions. It's likely the request is incorrect.": "This application didn't ask for known permissions. It's likely the request is incorrect.",
  "This application will be able to access all of your informations and post content. Make sure you only approve applications you trust.": "This application will be able to access all of your informations and post content. Make sure you only approve applications you trust.",
  "This application will be allowed to access all of the groups you're a member of": "This application will be allowed to access all of the groups you're a member of",
  "This application will be allowed to access group activities in all of the groups you're a member of": "This application will be allowed to access group activities in all of the groups you're a member of",
  "This application will be allowed to access your user activity settings": "This application will be allowed to access your user activity settings",
  "This application will be allowed to access your user settings": "This application will be allowed to access your user settings",
  "This application will be allowed to create feed tokens": "This application will be allowed to create feed tokens",
  "This application will be allowed to create group discussions": "This application will be allowed to create group discussions",
  "This application will be allowed to create new profiles for your account": "This application will be allowed to create new profiles for your account",
  "This application will be allowed to create resources in all of the groups you're a member of": "This application will be allowed to create resources in all of the groups you're a member of",
  "This application will be allowed to delete comments": "This application will be allowed to delete comments",
  "This application will be allowed to delete events": "This application will be allowed to delete events",
  "This application will be allowed to delete feed tokens": "This application will be allowed to delete feed tokens",
  "This application will be allowed to delete group discussions": "This application will be allowed to delete group discussions",
  "This application will be allowed to delete group posts": "This application will be allowed to delete group posts",
  "This application will be allowed to delete resources in all of the groups you're a member of": "This application will be allowed to delete resources in all of the groups you're a member of",
  "This application will be allowed to delete your profiles": "This application will be allowed to delete your profiles",
  "This application will be allowed to join and leave groups": "This application will be allowed to join and leave groups",
  "This application will be allowed to list and access group discussions in all of the groups you're a member of": "This application will be allowed to list and access group discussions in all of the groups you're a member of",
  "This application will be allowed to list and access group events in all of the groups you're a member of": "This application will be allowed to list and access group events in all of the groups you're a member of",
  "This application will be allowed to list and access group todo-lists in all of the groups you're a member of": "This application will be allowed to list and access group todo-lists in all of the groups you're a member of",
  "This application will be allowed to list and view the events you're participating to": "This application will be allowed to list and view the events you're participating to",
  "This application will be allowed to list and view the groups you're a member of": "This application will be allowed to list and view the groups you're a member of",
  "This application will be allowed to list and view the groups you're following": "This application will be allowed to list and view the groups you're following",
  "This application will be allowed to list and view your draft events": "This application will be allowed to list and view your draft events",
  "This application will be allowed to list and view your organized events": "This application will be allowed to list and view your organized events",
  "This application will be allowed to list group followers in all of the groups you're a member of": "This application will be allowed to list group followers in all of the groups you're a member of",
  "This application will be allowed to list group members in all of the groups you're a member of": "This application will be allowed to list group members in all of the groups you're a member of",
  "This application will be allowed to list the media you've uploaded": "This application will be allowed to list the media you've uploaded",
  "This application will be allowed to list your suggested group events": "This application will be allowed to list your suggested group events",
  "This application will be allowed to manage events participations": "This application will be allowed to manage events participations",
  "This application will be allowed to manage group members in all of the groups you're a member of": "This application will be allowed to manage group members in all of the groups you're a member of",
  "This application will be allowed to manage your account activity settings": "This application will be allowed to manage your account activity settings",
  "This application will be allowed to manage your account push notification settings": "This application will be allowed to manage your account push notification settings",
  "This application will be allowed to post comments": "This application will be allowed to post comments",
  "This application will be allowed to publish and manage events, post and manage comments, participate to events, manage all of your groups, including group events, resources, posts and discussions. It will also be allowed to manage your account and profile settings.": "This application will be allowed to publish and manage events, post and manage comments, participate to events, manage all of your groups, including group events, resources, posts and discussions. It will also be allowed to manage your account and profile settings.",
  "This application will be allowed to publish events": "This application will be allowed to publish events",
  "This application will be allowed to publish events, participate to events": "",
  "This application will be allowed to publish group posts": "This application will be allowed to publish group posts",
  "This application will be allowed to remove uploaded media": "This application will be allowed to remove uploaded media",
  "This application will be allowed to see all of your events organized, the events you participate to, \u2026": "",
  "This application will be allowed to see all of your events organized, the events you participate to, as well as every data from your groups.": "This application will be allowed to see all of your events organized, the events you participate to, as well as every data from your groups.",
  "This application will be allowed to update comments": "This application will be allowed to update comments",
  "This application will be allowed to update events": "This application will be allowed to update events",
  "This application will be allowed to update group discussions": "This application will be allowed to update group discussions",
  "This application will be allowed to update group posts": "This application will be allowed to update group posts",
  "This application will be allowed to update resources in all of the groups you're a member of": "This application will be allowed to update resources in all of the groups you're a member of",
  "This application will be allowed to update your profiles": "This application will be allowed to update your profiles",
  "This application will be allowed to upload media": "This application will be allowed to upload media",
  "This event has been cancelled.": "This event has been cancelled.",
  "This event is accessible only through it's link. Be careful where you post this link.": "This event is accessible only through it's link. Be careful where you post this link.",
  "This group doesn't have a description yet.": "This group doesn't have a description yet.",
  "This group is a remote group, it's possible the original instance has more informations.": "This group is a remote group, it's possible the original instance has more informations.",
  "This group is accessible only through it's link. Be careful where you post this link.": "This group is accessible only through it's link. Be careful where you post this link.",
  "This group is invite-only": "This group is invite-only",
  "This group was not found": "This group was not found",
  "This identifier is unique to your profile. It allows others to find you.": "This identifier is unique to your profile. It allows others to find you.",
  "This information is saved only on your computer. Click for details": "This information is saved only on your computer. Click for details",
  "This instance doesn't follow yours.": "This instance doesn't follow yours.",
  "This instance hasn't got push notifications enabled.": "This instance hasn't got push notifications enabled.",
  "This instance isn't opened to registrations, but you can register on other instances.": "This instance isn't opened to registrations, but you can register on other instances.",
  "This instance, <b>{instanceName} ({domain})</b>, hosts your profile, so remember its name.": "This instance, <b>{instanceName} ({domain})</b>, hosts your profile, so remember its name.",
  "This instance, {instanceName}, hosts your profile, so remember its name.": "This instance, {instanceName}, hosts your profile, so remember its name.",
  "This is a announcement from the organizers of event {event}. You can't reply to it, but you can send a private message to event organizers.": "This is a announcement from the organizers of event {event}. You can't reply to it, but you can send a private message to event organizers.",
  "This is a demonstration site to test Mobilizon.": "This is a demonstration site to test Mobilizon.",
  "This is like your federated username (<code>{username}</code>) for groups. It will allow the group to be found on the federation, and is guaranteed to be unique.": "This is like your federated username (<code>{username}</code>) for groups. It will allow the group to be found on the federation, and is guaranteed to be unique.",
  "This is like your federated username ({username}) for groups. It will allow the group to be found on the federation, and is guaranteed to be unique.": "This is like your federated username ({username}) for groups. It will allow the group to be found on the federation, and is guaranteed to be unique.",
  "This is your personal profile and should not be used to describe your organization. After personal profile creation you can create a group for your organization.":"This is your personal profile and should not be used to describe your organization. After personal profile creation you can create a group for your organization.",
  "This month": "This month",
  "This post is accessible only for members. You have access to it for moderation purposes only because you are an instance moderator.": "This post is accessible only for members. You have access to it for moderation purposes only because you are an instance moderator.",
  "This post is accessible only through it's link. Be careful where you post this link.": "This post is accessible only through it's link. Be careful where you post this link.",
  "This profile is from another instance, the informations shown here may be incomplete.": "This profile is from another instance, the informations shown here may be incomplete.",
  "This profile is located on this instance, so you need to {access_the_corresponding_account} to ban it.": "This profile is located on this instance, so you need to {access_the_corresponding_account} to ban it.",
  "This profile was not found": "This profile was not found",
  "This section lets you add links to external websites to the menu.": "This section lets you add links to external websites to the menu.",
  "This setting will be used to display the website and send you emails in the correct language.": "This setting will be used to display the website and send you emails in the correct language.",
  "This user doesn't have any profiles": "This user doesn't have any profiles",
  "This user was not found": "This user was not found",
  "This website isn't moderated and the data that you enter will be automatically destroyed every day at 00:01 (Paris timezone).": "This website isn't moderated and the data that you enter will be automatically destroyed every day at 00:01 (Paris timezone).",
  "This week": "This week",
  "This weekend": "This weekend",
  "This will also resolve the report.": "This will also resolve the report.",
  "This will delete / anonymize all content (events, comments, messages, participations\u2026) created from this identity.": "This will delete / anonymize all content (events, comments, messages, participations\u2026) created from this identity.",
  "Time in your timezone ({timezone})": "Time in your timezone ({timezone})",
  "Times in your timezone ({timezone})": "Times in your timezone ({timezone})",
  "Timezone detected as {timezone}.": "Timezone detected as {timezone}.",
  "Timezone parameters": "Timezone parameters",
  "Timezone": "Timezone",
  "Title": "Title",
  "To activate more notifications, head over to the notification settings.": "To activate more notifications, head over to the notification settings.",
  "To confirm, type your event title \"{eventTitle}\"": "To confirm, type your event title \"{eventTitle}\"",
  "To confirm, type your identity username \"{preferredUsername}\"": "To confirm, type your identity username \"{preferredUsername}\"",
  "To create and manage multiples identities from a same account": "To create and manage multiples identities from a same account",
  "To create and manage your events": "To create and manage your events",
  "To create or join an group and start organizing with other people": "To create or join an group and start organizing with other people",
  "To follow groups and be informed of their latest events": "To follow groups and be informed of their latest events",
  "To register for an event by choosing one of your identities": "To register for an event by choosing one of your identities",
  "Today": "Today",
  "Token":"Token",
  "Tomorrow": "Tomorrow",
  "Tools": "Tools",
  "Total number of participations": "Total number of participations",
  "Transfer to {outsideDomain}": "Transfer to {outsideDomain}",
  "Triggered profile refreshment": "Triggered profile refreshment",
  "Try different keywords.": "Try different keywords.",
  "Try fewer keywords.": "Try fewer keywords.",
  "Try more general keywords.": "Try more general keywords.",
  "Twitch live": "Twitch live",
  "Twitch replay": "Twitch replay",
  "Twitter account": "Twitter account",
  "Type or select a date\u2026": "Type or select a date\u2026",
  "Type": "Type",
  "URL copied to clipboard": "URL copied to clipboard",
  "URL": "URL",
  "Unable to copy to clipboard": "Unable to copy to clipboard",
  "Unable to create the group. One of the pictures may be too heavy.": "Unable to create the group. One of the pictures may be too heavy.",
  "Unable to create the profile. The avatar picture may be too heavy.": "Unable to create the profile. The avatar picture may be too heavy.",
  "Unable to detect timezone.": "Unable to detect timezone.",
  "Unable to load event for participation. The error details are provided below:": "Unable to load event for participation. The error details are provided below:",
  "Unable to save your participation in this browser.": "Unable to save your participation in this browser.",
  "Unable to update the profile. The avatar picture may be too heavy.": "Unable to update the profile. The avatar picture may be too heavy.",
  "Unban the account": "Unban the account",
  "Unban the account?": "Unban the account?",
  "Unban": "Unban",
  "Underline": "Underline",
  "Undo": "Undo",
  "Unfollow": "Unfollow",
  "Unfortunately, your participation request was rejected by the organizers.": "Unfortunately, your participation request was rejected by the organizers.",
  "Unknown actor": "Unknown actor",
  "Unknown error.": "Unknown error.",
  "Unknown value for the openness setting.": "Unknown value for the openness setting.",
  "Unknown": "Unknown",
  "Unlogged participation": "Unlogged participation",
  "Unsaved changes": "Unsaved changes",
  "Unsubscribe to browser push notifications": "Unsubscribe to browser push notifications",
  "Unsuspend": "Unsuspend",
  "Upcoming events from your groups": "Upcoming events from your groups",
  "Upcoming events nearby {position}": "Upcoming events nearby {position}",
  "Upcoming events": "Upcoming events",
  "Upcoming": "Upcoming",
  "Update app": "Update app",
  "Update comments": "Update comments",
  "Update discussion title": "Update discussion title",
  "Update event {name}": "Update event {name}",
  "Update events": "Update events",
  "Update group discussions": "Update group discussions",
  "Update group posts": "Update group posts",
  "Update group resources": "Update group resources",
  "Update group": "Update group",
  "Update label":"Update label",
  "Update my event": "Update my event",
  "Update my profile": "Update my profile",
  "Update post": "Update post",
  "Update profiles": "Update profiles",
  "Update": "Update",
  "Updated at": "Updated at",
  "Updated": "Updated",
  "Upload media": "Upload media",
  "Uploaded media size": "Uploaded media size",
  "Uploaded media total size": "Uploaded media total size",
  "Use my location": "Use my location",
  "User settings": "User settings",
  "User suspended and report resolved": "User suspended and report resolved",
  "User": "User",
  "Username": "Username",
  "Users pending for moderation": "Users pending for moderation",
  "Users": "Users",
  "Validating account": "Validating account",
  "Validating email": "Validating email",
  "Video Conference": "Video Conference",
  "View a reply": "View no replies|View one reply|View {totalReplies} replies",
  "View account on {hostname} (in a new window)": "View account on {hostname} (in a new window)",
  "View all categories": "View all categories",
  "View all events": "View all events",
  "View all posts": "View all posts",
  "View all": "View all",
  "View event page": "View event page",
  "View everything": "View everything",
  "View full profile": "View full profile",
  "View less": "View less",
  "View more events and activities around {position}": "View more events and activities around {position}",
  "View more events and activities": "View more events and activities",
  "View more events around {position}": "View more events around {position}",
  "View more events": "View more events",
  "View more groups around {position}": "View more groups around {position}",
  "View more online events": "View more online events",
  "View more": "View more",
  "View page on {hostname} (in a new window)": "View page on {hostname} (in a new window)",
  "View past activities": "View past activities",
  "View past events": "View past events",
  "View the group profile on the original instance": "View the group profile on the original instance",
  "Visibility was set to an unknown value.": "Visibility was set to an unknown value.",
  "Visibility was set to private.": "Visibility was set to private.",
  "Visibility was set to public.": "Visibility was set to public.",
  "Visible everywhere on the web (public)": "Visible everywhere on the web (public)",
  "Visible everywhere on the web": "Visible everywhere on the web",
  "Visit {instance_domain}": "Visit {instance_domain}",
  "Waiting for organization team approval.": "Waiting for organization team approval.",
  "Warning": "Warning",
  "We asked to follow them":"We asked to follow them",
  "We collect your feedback and the error information in order to improve this service.": "We collect your feedback and the error information in order to improve this service.",
  "We couldn't save your participation inside this browser. Not to worry, you have successfully confirmed your participation, we just couldn't save it's status in this browser because of a technical issue.": "We couldn't save your participation inside this browser. Not to worry, you have successfully confirmed your participation, we just couldn't save it's status in this browser because of a technical issue.",
  "We follow them":"We follow them",
  "We improve this software thanks to your feedback. To let us know about this issue, two possibilities (both unfortunately require user account creation):": "We improve this software thanks to your feedback. To let us know about this issue, two possibilities (both unfortunately require user account creation):",
  "We just sent an email to {email}": "We just sent an email to {email}",
  "We use your timezone to make sure you get notifications for an event at the correct time.": "We use your timezone to make sure you get notifications for an event at the correct time.",
  "We will redirect you to your instance in order to interact with this event": "We will redirect you to your instance in order to interact with this event",
  "We will redirect you to your instance in order to interact with this group": "We will redirect you to your instance in order to interact with this group",
  "We'll send you an email one hour before the event begins, to be sure you won't forget about it.": "We'll send you an email one hour before the event begins, to be sure you won't forget about it.",
  "We'll use your timezone settings to send a recap of the morning of the event.": "We'll use your timezone settings to send a recap of the morning of the event.",
  "Website / URL": "Website / URL",
  "Website": "Website",
  "Week": "Week",
  "Weekly email summary": "Weekly email summary",
  "Welcome back {username}!": "Welcome back {username}!",
  "Welcome back!": "Welcome back!",
  "Welcome to Mobilizon, {username}!": "Welcome to Mobilizon, {username}!",
  "What can I do to help?": "What can I do to help?",
  "What happened?": "What happened?",
  "Wheelchair accessibility": "Wheelchair accessibility",
  "When a moderator from the group creates an event and attributes it to the group, it will show up here.": "When a moderator from the group creates an event and attributes it to the group, it will show up here.",
  "When the event is private, you'll need to share the link around.": "When the event is private, you'll need to share the link around.",
  "When the post is private, you'll need to share the link around.": "When the post is private, you'll need to share the link around.",
  "Whether smoking is prohibited during the event": "Whether smoking is prohibited during the event",
  "Whether the event is accessible with a wheelchair": "Whether the event is accessible with a wheelchair",
  "Whether the event is interpreted in sign language": "Whether the event is interpreted in sign language",
  "Whether the event live video is subtitled": "Whether the event live video is subtitled",
  "Who can post a comment?": "Who can post a comment?",
  "Who can view this event and participate": "Who can view this event and participate",
  "Who can view this post": "Who can view this post",
  "Who published {number} events": "Who published {number} events",
  "Why create an account?": "Why create an account?",
  "Will allow to display and manage your participation status on the event page when using this device. Uncheck if you're using a public device.": "Will allow to display and manage your participation status on the event page when using this device. Uncheck if you're using a public device.",
  "With the most participants": "With the most participants",
  "With unknown participants": "With unknown participants",
  "With {participants}": "With {participants}",
  "Within {number} kilometers of {place}": "|Within one kilometer of {place}|Within {number} kilometers of {place}",
  "Write a new comment": "Write a new comment",
  "Write a new message": "Write a new message",
  "Write a new reply": "Write a new reply",
  "Write something": "Write something",
  "Write your post": "Write your post",
  "Yesterday": "Yesterday",
  "You ({invitedActor}) have been invited by {invitedBy} to the following group:": "You ({invitedActor}) have been invited by {invitedBy} to the following group:",
  "You accepted the invitation to join the group.": "You accepted the invitation to join the group.",
  "You added the member {member}.": "You added the member {member}.",
  "You approved {member}'s membership.": "You approved {member}'s membership.",
  "You archived the discussion {discussion}.": "You archived the discussion {discussion}.",
  "You are not an administrator for this group.": "You are not an administrator for this group.",
  "You are not part of any group.": "You are not part of any group.",
  "You are offline": "You are offline",
  "You are participating in this event anonymously but didn't confirm participation": "You are participating in this event anonymously but didn't confirm participation",
  "You are participating in this event anonymously": "You are participating in this event anonymously",
  "You can add resources by using the button above.": "You can add resources by using the button above.",
  "You can add tags by hitting the Enter key or by adding a comma": "You can add tags by hitting the Enter key or by adding a comma",
  "You can create a new profile or change the actual profile with the profile menu.": "You can create a new profile or change the actual profile with the profile menu.",
  "You can create another invitation link with the button \"New invitation\".":  "You can create another invitation link with the button \"New invitation\".",
  "You can drag and drop the marker below to the desired location": "You can drag and drop the marker below to the desired location",
  "You can pick your timezone into your preferences.": "You can pick your timezone into your preferences.",
  "You can put any arbitrary content in this element. URLs will be clickable.": "You can put any arbitrary content in this element. URLs will be clickable.",
  "You can try another search term or add the address details manually below.": "You can try another search term or add the address details manually below.",
  "You can try another search term or drag and drop the marker on the map": "You can try another search term or drag and drop the marker on the map",
  "You can't change your password because you are registered through {provider}.": "You can't change your password because you are registered through {provider}.",
  "You can't use push notifications in this browser.": "You can't use push notifications in this browser.",
  "You changed your email or password": "You changed your email or password",
  "You created the discussion {discussion}.": "You created the discussion {discussion}.",
  "You created the event {event}.": "You created the event {event}.",
  "You created the folder {resource}.": "You created the folder {resource}.",
  "You created the group {group}.": "You created the group {group}.",
  "You created the post {post}.": "You created the post {post}.",
  "You created the resource {resource}.": "You created the resource {resource}.",
  "You deleted the discussion {discussion}.": "You deleted the discussion {discussion}.",
  "You deleted the event {event}.": "You deleted the event {event}.",
  "You deleted the folder {resource}.": "You deleted the folder {resource}.",
  "You deleted the post {post}.": "You deleted the post {post}.",
  "You deleted the resource {resource}.": "You deleted the resource {resource}.",
  "You demoted the member {member} to an unknown role.": "You demoted the member {member} to an unknown role.",
  "You demoted {member} to moderator.": "You demoted {member} to moderator.",
  "You demoted {member} to simple member.": "You demoted {member} to simple member.",
  "You didn't create or join any event yet.": "You didn't create or join any event yet.",
  "You don't follow any instances yet.": "You don't follow any instances yet.",
  "You don't have any upcoming events. Maybe try another filter?": "You don't have any upcoming events. Maybe try another filter?",
  "You excluded member {member}.": "You excluded member {member}.",
  "You have access to this conversation as a member of the {group} group": "You have access to this conversation as a member of the {group} group",
  "You have attended {count} events in the past.": "You have not attended any events in the past.|You have attended one event in the past.|You have attended {count} events in the past.",
  "You have been logged-out": "You have been logged-out",
  "You have been removed from this group's members.": "You have been removed from this group's members.",
  "You have cancelled your participation": "You have cancelled your participation",
  "You have one event in {days} days.": "You have no events in {days} days | You have one event in {days} days. | You have {count} events in {days} days",
  "You have one event today.": "You have no events today | You have one event today. | You have {count} events today",
  "You have one event tomorrow.": "You have no events tomorrow | You have one event tomorrow. | You have {count} events tomorrow",
  "You have to create and select a profile to fully use Mobilizon.": "You have to create and select a profile to fully use Mobilizon.",
  "You haven't interacted with other instances yet.": "You haven't interacted with other instances yet.",
  "You invited {member}.": "You invited {member}.",
  "You joined the event {event}.": "You joined the event {event}.",
  "You may also:": "You may also:",
  "You may clear all participation information for this device with the buttons below.": "You may clear all participation information for this device with the buttons below.",
  "You may now close this page or {return_to_the_homepage}.": "You may now close this page or {return_to_the_homepage}.",
  "You may now close this window, or {return_to_event}.": "You may now close this window, or {return_to_event}.",
  "You may show some members as contacts.": "You may show some members as contacts.",
  "You moved the folder {resource} into {new_path}.": "You moved the folder {resource} into {new_path}.",
  "You moved the folder {resource} to the root folder.": "You moved the folder {resource} to the root folder.",
  "You moved the resource {resource} into {new_path}.": "You moved the resource {resource} into {new_path}.",
  "You moved the resource {resource} to the root folder.": "You moved the resource {resource} to the root folder.",
  "You need to enter a text": "You need to enter a text",
  "You need to login.": "You need to login.",
  "You need to provide the following code to your application. It will only be valid for a few minutes.": "You need to provide the following code to your application. It will only be valid for a few minutes.",
  "You posted a comment on the event {event}.": "You posted a comment on the event {event}.",
  "You promoted the member {member} to an unknown role.": "You promoted the member {member} to an unknown role.",
  "You promoted {member} to administrator.": "You promoted {member} to administrator.",
  "You promoted {member} to moderator.": "You promoted {member} to moderator.",
  "You rejected {member}'s membership request.": "You rejected {member}'s membership request.",
  "You renamed the discussion from {old_discussion} to {discussion}.": "You renamed the discussion from {old_discussion} to {discussion}.",
  "You renamed the folder from {old_resource_title} to {resource}.": "You renamed the folder from {old_resource_title} to {resource}.",
  "You renamed the resource from {old_resource_title} to {resource}.": "You renamed the resource from {old_resource_title} to {resource}.",
  "You replied to a comment on the event {event}.": "You replied to a comment on the event {event}.",
  "You replied to the discussion {discussion}.": "You replied to the discussion {discussion}.",
  "You requested to join the group.": "You requested to join the group.",
  "You successfully joined the group {groupName} with your profile {preferredUsername}.": "You successfully joined the group {groupName} with your profile {preferredUsername}.",
  "You updated the event {event}.": "You updated the event {event}.",
  "You updated the group {group}.": "You updated the group {group}.",
  "You updated the member {member}.": "You updated the member {member}.",
  "You updated the post {post}.": "You updated the post {post}.",
  "You were demoted to an unknown role by {profile}.": "You were demoted to an unknown role by {profile}.",
  "You were demoted to moderator by {profile}.": "You were demoted to moderator by {profile}.",
  "You were demoted to simple member by {profile}.": "You were demoted to simple member by {profile}.",
  "You were promoted to administrator by {profile}.": "You were promoted to administrator by {profile}.",
  "You were promoted to an unknown role by {profile}.": "You were promoted to an unknown role by {profile}.",
  "You were promoted to moderator by {profile}.": "You were promoted to moderator by {profile}.",
  "You will be able to add an avatar and set other options in your account settings.": "You will be able to add an avatar and set other options in your account settings.",
  "You will be redirected to the original instance": "You will be redirected to the original instance",
  "You will find here all the events you have created or of which you are a participant, as well as events organized by groups you follow or are a member of.": "You will find here all the events you have created or of which you are a participant, as well as events organized by groups you follow or are a member of.",
  "You will receive notifications about this group's public activity depending on %{notification_settings}.": "You will receive notifications about this group's public activity depending on %{notification_settings}.",
  "You wish to participate to the following event": "You wish to participate to the following event",
  "You'll be able to revoke access for this application in your account settings.": "You'll be able to revoke access for this application in your account settings.",
  "You'll get a weekly recap every Monday for upcoming events, if you have any.": "You'll get a weekly recap every Monday for upcoming events, if you have any.",
  "You'll need to change the URLs where there were previously entered.": "You'll need to change the URLs where there were previously entered.",
  "You'll need to transmit the group URL so people may access the group's profile. The group won't be findable in Mobilizon's search or regular search engines.": "You'll need to transmit the group URL so people may access the group's profile. The group won't be findable in Mobilizon's search or regular search engines.",
  "You'll receive a confirmation email.": "You'll receive a confirmation email.",
  "YouTube live": "YouTube live",
  "YouTube replay": "YouTube replay",
  "Your account has been successfully deleted": "Your account has been successfully deleted",
  "Your account has been validated": "Your account has been validated",
  "Your account is being validated": "Your account is being validated",
  "Your account is nearly ready": "Your account is nearly ready",
  "Your application code": "Your application code",
  "Your city or region and the radius will only be used to suggest you events nearby. The event radius will consider the administrative center of the area.": "Your city or region and the radius will only be used to suggest you events nearby. The event radius will consider the administrative center of the area.",
  "Your current email is {email}. You use it to log in.": "Your current email is {email}. You use it to log in.",
  "Your email address was automatically set based on your {provider} account.": "Your email address was automatically set based on your {provider} account.",
  "Your email has been changed": "Your email has been changed",
  "Your email is being changed": "Your email is being changed",
  "Your email will only be used to confirm that you're a real person and send you eventual updates for this event. It will NOT be transmitted to other instances or to the event organizer.": "Your email will only be used to confirm that you're a real person and send you eventual updates for this event. It will NOT be transmitted to other instances or to the event organizer.",
  "Your email": "Your email",
  "Your federated identity": "Your federated identity",
  "Your membership is pending approval": "Your membership is pending approval",
  "Your membership was approved by {profile}.": "Your membership was approved by {profile}.",
  "Your participation has been cancelled": "Your participation has been cancelled",
  "Your participation has been confirmed": "Your participation has been confirmed",
  "Your participation has been rejected": "Your participation has been rejected",
  "Your participation has been requested": "Your participation has been requested",
  "Your participation is being cancelled": "Your participation is being cancelled",
  "Your participation request has been validated": "Your participation has been validated",
  "Your participation request is being validated": "Your participation is being validated",
  "Your participation status has been changed": "Your participation status has been changed",
  "Your participation status is saved only on this device and will be deleted one month after the event's passed.": "Your participation status is saved only on this device and will be deleted one month after the event's passed.",
  "Your participation still has to be approved by the organisers.": "Your participation still has to be approved by the organisers.",
  "Your participation will be validated once you click the confirmation link into the email, and after the organizer manually validates your participation.": "Your participation will be validated once you click the confirmation link into the email, and after the organizer manually validates your participation.",
  "Your participation will be validated once you click the confirmation link into the email.": "Your participation will be validated once you click the confirmation link into the email.",
  "Your password has been successfully changed. You now need to logged-in with your new password.": "Your password has been successfully changed. You now need to logged-in with your new password.",
  "Your position was not available.": "Your position was not available.",
  "Your profile will be shown as contact.": "Your profile will be shown as contact.",
  "Your timezone is currently set to {timezone}.": "Your timezone is currently set to {timezone}.",
  "Your timezone was detected as {timezone}.": "Your timezone was detected as {timezone}.",
  "Your timezone {timezone} isn't supported.": "Your timezone {timezone} isn't supported.",
  "Your upcoming events": "Your upcoming events",
  "Zoom in": "Zoom in",
  "Zoom out": "Zoom out",
  "Zoom": "Zoom",
  "[This comment has been deleted by it's author]": "[This comment has been deleted by it's author]",
  "[This comment has been deleted]": "[This comment has been deleted]",
  "[deleted]": "[deleted]",
  "\u00a9 The OpenStreetMap Contributors": "\u00a9 The OpenStreetMap Contributors",
  "a non-existent report": "a non-existent report",
  "access the corresponding account": "access the corresponding account",
  "access to the group's private content as well": "access to the group's private content as well",
  "and {number} groups": "and {number} groups",
  "any distance": "any distance",
  "as {identity}": "as {identity}",
  "contact uninformed": "contact uninformed",
  "create a group": "create a group",
  "create an activity": "create an activity",
  "create an event": "create an event",
  "default Mobilizon privacy policy": "default Mobilizon privacy policy",
  "default Mobilizon terms": "default Mobilizon terms",
  "detail": "",
  "e.g. 10 Rue Jangot": "e.g. 10 Rue Jangot",
  "e.g. Accessibility, Twitch, PeerTube": "e.g. Accessibility, Twitch, PeerTube",
  "e.g. Nantes, Berlin, Cork, \u2026": "e.g. Nantes, Berlin, Cork, \u2026",
  "enable the feature": "enable the feature",
  "explore the events": "explore the events",
  "explore the groups": "explore the groups",
  "find, create and organise events": "find, create and organise events",
  "full rules": "full rules",
  "group's upcoming public events": "group's upcoming public events",
  "https://mensuel.framapad.org/p/some-secret-token": "https://mensuel.framapad.org/p/some-secret-token",
  "iCal Feed": "iCal Feed",
  "instance rules": "instance rules",
  "mobilizon-instance.tld": "mobilizon-instance.tld",
  "more than 1360 contributors": "more than 1360 contributors",
  "multitude of interconnected Mobilizon websites": "multitude of interconnected Mobilizon websites",
  "new{'@'}email.com": "new{'@'}email.com",
  "profile@instance": "profile@instance",
  "profile{'@'}instance": "profile{'@'}instance",
  "profile{\\'@\\'}instance": "profile{\\'@\\'}instance",
  "report #{report_number}": "report #{report_number}",
  "return to the event's page": "return to the event's page",
  "return to the homepage": "return to the homepage",
  "terms of service": "terms of service",
  "tool designed to serve you": "tool designed to serve you",
  "translation": "",
  "with another identity\u2026": "with another identity\u2026",
  "your notification settings": "your notification settings",
  "{'@'}{username} ({role})": "{'@'}{username} ({role})",
  "{'@'}{username}": "{'@'}{username}",
  "{approved} / {total} seats": "{approved} / {total} seats",
  "{available}/{capacity} available places": "No places left|{available}/{capacity} available place left|{available}/{capacity} available places",
  "{count} events": "{count} events",
  "{count} instances found": "No instance found|One instance found|{count} instances found",
  "{count} km": "{count} km",
  "{count} members or followers": "No members or followers|One member or follower|{count} members or followers",
  "{count} members": "No members|One member|{count} members",
  "{count} participants": "No participants yet | One participant | {count} participants",
  "{count} requests waiting": "{count} requests waiting",
  "{eventsCount} activities found": "No activities found|One activity found|{eventsCount} activities found",
  "{eventsCount} events found": "No events found|One event found|{eventsCount} events found",
  "{folder} - Resources": "{folder} - Resources",
  "{groupsCount} groups found": "No groups found|One group found|{groupsCount} groups found",
  "{group} activity timeline": "{group} activity timeline",
  "{group} events": "{group} events",
  "{group} posts": "{group} posts",
  "{group}'s events": "{group}'s events",
  "{group}'s todolists": "{group}'s todolists",
  "{instanceName} ({domain})": "{instanceName} ({domain})",
  "{instanceName} is an instance of the {mobilizon} software.": "{instanceName} is an instance of the {mobilizon} software.",
  "{instanceName} is an instance of {mobilizon_link}, a free software built with the community.": "{instanceName} is an instance of {mobilizon_link}, a free software built with the community.",
  "{member} accepted the invitation to join the group.": "{member} accepted the invitation to join the group.",
  "{member} joined the group.": "{member} joined the group.",
  "{member} rejected the invitation to join the group.": "{member} rejected the invitation to join the group.",
  "{member} requested to join the group.": "{member} requested to join the group.",
  "{member} was invited by {profile}.": "{member} was invited by {profile}.",
  "{moderator} added a note on {report}": "{moderator} added a note on {report}",
  "{moderator} closed {report}": "{moderator} closed {report}",
  "{moderator} deleted an event named \"{title}\"": "{moderator} deleted an event named \"{title}\"",
  "{moderator} has deleted a comment from {author} under the event {event}": "{moderator} has deleted a comment from {author} under the event {event}",
  "{moderator} has deleted a comment from {author}": "{moderator} has deleted a comment from {author}",
  "{moderator} has deleted user {user}": "{moderator} has deleted user {user}",
  "{moderator} has done an unknown action": "{moderator} has done an unknown action",
  "{moderator} has unsuspended group {profile}": "{moderator} has unsuspended group {profile}",
  "{moderator} has unsuspended profile {profile}": "{moderator} has unsuspended profile {profile}",
  "{moderator} marked {report} as resolved": "{moderator} marked {report} as resolved",
  "{moderator} reopened {report}": "{moderator} reopened {report}",
  "{moderator} suspended group {profile}": "{moderator} suspended group {profile}",
  "{moderator} suspended profile {profile}": "{moderator} suspended profile {profile}",
  "{nb} km": "{nb} km",
  "{numberOfCategories} selected": "{numberOfCategories} selected",
  "{numberOfLanguages} selected": "{numberOfLanguages} selected",
  "{number} kilometers": "{number} kilometers",
  "{number} members": "{number} members",
  "{number} memberships": "{number} memberships",
  "{number} organized events": "No organized events|One organized event|{number} organized events",
  "{number} participations": "No participations|One participation|{number} participations",
  "{number} posts": "No posts|One post|{number} posts",
  "{old_group_name} was renamed to {group}.": "{old_group_name} was renamed to {group}.",
  "{profileName} (suspended)": "{profileName} (suspended)",
  "{profile} (by default)": "{profile} (by default)",
  "{profile} added the member {member}.": "{profile} added the member {member}.",
  "{profile} approved {member}'s membership.": "{profile} approved {member}'s membership.",
  "{profile} archived the discussion {discussion}.": "{profile} archived the discussion {discussion}.",
  "{profile} created the discussion {discussion}.": "{profile} created the discussion {discussion}.",
  "{profile} created the folder {resource}.": "{profile} created the folder {resource}.",
  "{profile} created the group {group}.": "{profile} created the group {group}.",
  "{profile} created the resource {resource}.": "{profile} created the resource {resource}.",
  "{profile} deleted the discussion {discussion}.": "{profile} deleted the discussion {discussion}.",
  "{profile} deleted the folder {resource}.": "{profile} deleted the folder {resource}.",
  "{profile} deleted the resource {resource}.": "{profile} deleted the resource {resource}.",
  "{profile} demoted {member} to an unknown role.": "{profile} demoted {member} to an unknown role.",
  "{profile} demoted {member} to moderator.": "{profile} demoted {member} to moderator.",
  "{profile} demoted {member} to simple member.": "{profile} demoted {member} to simple member.",
  "{profile} excluded member {member}.": "{profile} excluded member {member}.",
  "{profile} joined the the event {event}.": "{profile} joined the the event {event}.",
  "{profile} moved the folder {resource} into {new_path}.": "{profile} moved the folder {resource} into {new_path}.",
  "{profile} moved the folder {resource} to the root folder.": "{profile} moved the folder {resource} to the root folder.",
  "{profile} moved the resource {resource} into {new_path}.": "{profile} moved the resource {resource} into {new_path}.",
  "{profile} moved the resource {resource} to the root folder.": "{profile} moved the resource {resource} to the root folder.",
  "{profile} posted a comment on the event {event}.": "{profile} posted a comment on the event {event}.",
  "{profile} promoted {member} to administrator.": "{profile} promoted {member} to administrator.",
  "{profile} promoted {member} to an unknown role.": "{profile} promoted {member} to an unknown role.",
  "{profile} promoted {member} to moderator.": "{profile} promoted {member} to moderator.",
  "{profile} quit the group.": "{profile} quit the group.",
  "{profile} rejected {member}'s membership request.": "{profile} rejected {member}'s membership request.",
  "{profile} renamed the discussion from {old_discussion} to {discussion}.": "{profile} renamed the discussion from {old_discussion} to {discussion}.",
  "{profile} renamed the folder from {old_resource_title} to {resource}.": "{profile} renamed the folder from {old_resource_title} to {resource}.",
  "{profile} renamed the resource from {old_resource_title} to {resource}.": "{profile} renamed the resource from {old_resource_title} to {resource}.",
  "{profile} replied to a comment on the event {event}.": "{profile} replied to a comment on the event {event}.",
  "{profile} replied to the discussion {discussion}.": "{profile} replied to the discussion {discussion}.",
  "{profile} updated the group {group}.": "{profile} updated the group {group}.",
  "{profile} updated the member {member}.": "{profile} updated the member {member}.",
  "{resultsCount} results found": "No results found|On result found|{resultsCount} results found",
  "{timezoneLongName} ({timezoneShortName})": "{timezoneLongName} ({timezoneShortName})",
  "{title} ({count} todos)": "{title} ({count} todos)",
  "{username} was invited to {group}": "{username} was invited to {group}",
  "{user}'s follow request was accepted": "{user}'s follow request was accepted",
  "{user}'s follow request was rejected": "{user}'s follow request was rejected"
}
